// @ts-nocheck
/**
 * AUTO-GENERATED — do not edit by hand.
 * Source: src/theme/figma-tokens/*.tokens.json (from the UI/UX designer).
 * Regenerate: node scripts/build-primeng-preset.mjs
 *
 * A PrimeNG preset built from the designer's Figma design tokens. Wired into
 * the app via providePrimeNG({ theme: { preset: AgriFinOpsPreset } }).
 *
 * @ts-nocheck is intentional: the designer's tokens use PrimeNG's *nested*
 * object notation (e.g. { padding: { x, y } }, { hover: { background } }),
 * which PrimeNG resolves to CSS variables at runtime. PrimeNG's compile-time
 * token *types* only model the flat camelCase form (paddingX, hoverBackground),
 * so type-checking this generated data file would raise false positives.
 */
import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export const AgriFinOpsPreset = definePreset(Lara, {
  "primitive": {
    "amber": {
      "50": "#FFFBEB",
      "100": "#FEF3C7",
      "200": "#FDE68A",
      "300": "#FCD34D",
      "400": "#FBBF24",
      "500": "#F59E0B",
      "600": "#D97706",
      "700": "#B45309",
      "800": "#92400E",
      "900": "#78350F",
      "950": "#451A03"
    },
    "blue": {
      "50": "#EFF6FF",
      "100": "#DBEAFE",
      "200": "#BFDBFE",
      "300": "#93C5FD",
      "400": "#60A5FA",
      "500": "#3B82F6",
      "600": "#2563EB",
      "700": "#1D4ED8",
      "800": "#1E40AF",
      "900": "#1E3A8A",
      "950": "#172554"
    },
    "border": {
      "radius": {
        "none": "0px",
        "xs": "2px",
        "sm": "4px",
        "md": "6px",
        "lg": "8px",
        "xl": "12px"
      }
    },
    "cyan": {
      "50": "#ECFEFF",
      "100": "#CFFAFE",
      "200": "#A5F3FC",
      "300": "#67E8F9",
      "400": "#22D3EE",
      "500": "#06B6D4",
      "600": "#0891B2",
      "700": "#0E7490",
      "800": "#155E75",
      "900": "#164E63",
      "950": "#083344"
    },
    "emerald": {
      "50": "#ECFDF5",
      "100": "#D1FAE5",
      "200": "#A7F3D0",
      "300": "#6EE7B7",
      "400": "#34D399",
      "500": "#10B981",
      "600": "#059669",
      "700": "#047857",
      "800": "#065F46",
      "900": "#064E3B",
      "950": "#022C22"
    },
    "fuchsia": {
      "50": "#FDF4FF",
      "100": "#FAE8FF",
      "200": "#F5D0FE",
      "300": "#F0ABFC",
      "400": "#E879F9",
      "500": "#D946EF",
      "600": "#C026D3",
      "700": "#A21CAF",
      "800": "#86198F",
      "900": "#701A75",
      "950": "#4A044E"
    },
    "gray": {
      "50": "#F9FAFB",
      "100": "#F3F4F6",
      "200": "#E5E7EB",
      "300": "#D1D5DB",
      "400": "#9CA3AF",
      "500": "#6B7280",
      "600": "#4B5563",
      "700": "#374151",
      "800": "#1F2937",
      "900": "#111827",
      "950": "#030712"
    },
    "green": {
      "50": "#F0FDF4",
      "100": "#DCFCE7",
      "200": "#BBF7D0",
      "300": "#86EFAC",
      "400": "#4ADE80",
      "500": "#22C55E",
      "600": "#16A34A",
      "700": "#15803D",
      "800": "#166534",
      "900": "#14532D",
      "950": "#052E16"
    },
    "indigo": {
      "50": "#EEF2FF",
      "100": "#E0E7FF",
      "200": "#C7D2FE",
      "300": "#A5B4FC",
      "400": "#818CF8",
      "500": "#6366F1",
      "600": "#4F46E5",
      "700": "#4338CA",
      "800": "#3730A3",
      "900": "#312E81",
      "950": "#1E1B4B"
    },
    "lime": {
      "50": "#F7FEE7",
      "100": "#ECFCCB",
      "200": "#D9F99D",
      "300": "#BEF264",
      "400": "#A3E635",
      "500": "#84CC16",
      "600": "#65A30D",
      "700": "#4D7C0F",
      "800": "#3F6212",
      "900": "#365314",
      "950": "#1A2E05"
    },
    "neutral": {
      "50": "#FAFAFA",
      "100": "#F5F5F5",
      "200": "#E5E5E5",
      "300": "#D4D4D4",
      "400": "#A3A3A3",
      "500": "#737373",
      "600": "#525252",
      "700": "#404040",
      "800": "#262626",
      "900": "#171717",
      "950": "#0A0A0A"
    },
    "orange": {
      "50": "#FFF7ED",
      "100": "#FFEDD5",
      "200": "#FED7AA",
      "300": "#FDBA74",
      "400": "#FB923C",
      "500": "#F97316",
      "600": "#EA580C",
      "700": "#C2410C",
      "800": "#9A3412",
      "900": "#7C2D12",
      "950": "#431407"
    },
    "pink": {
      "50": "#FDF2F8",
      "100": "#FCE7F3",
      "200": "#FBCFE8",
      "300": "#F9A8D4",
      "400": "#F472B6",
      "500": "#EC4899",
      "600": "#DB2777",
      "700": "#BE185D",
      "800": "#9D174D",
      "900": "#831843",
      "950": "#500724"
    },
    "purple": {
      "50": "#FAF5FF",
      "100": "#F3E8FF",
      "200": "#E9D5FF",
      "300": "#D8B4FE",
      "400": "#C084FC",
      "500": "#A855F7",
      "600": "#9333EA",
      "700": "#7E22CE",
      "800": "#6B21A8",
      "900": "#581C87",
      "950": "#3B0764"
    },
    "red": {
      "50": "#FEF2F2",
      "100": "#FEE2E2",
      "200": "#FECACA",
      "300": "#FCA5A5",
      "400": "#F87171",
      "500": "#EF4444",
      "600": "#DC2626",
      "700": "#B91C1C",
      "800": "#991B1B",
      "900": "#7F1D1D",
      "950": "#450A0A"
    },
    "rose": {
      "50": "#FFF1F2",
      "100": "#FFE4E6",
      "200": "#FECDD3",
      "300": "#FDA4AF",
      "400": "#FB7185",
      "500": "#F43F5E",
      "600": "#E11D48",
      "700": "#BE123C",
      "800": "#9F1239",
      "900": "#881337",
      "950": "#4C0519"
    },
    "scale": {
      "1": "14px",
      "2": "28px",
      "3": "42px",
      "4": "56px",
      "5": "70px",
      "18": "252px",
      "25": "350px",
      "neg-1-5": "-21px",
      "neg-1-25": "-17.5px",
      "neg-1-125": "-15.75px",
      "neg-1": "-14px",
      "neg-0-875": "-12.25px",
      "neg-0-75": "-10.5px",
      "neg-0-625": "-8.75px",
      "neg-0-5": "-7px",
      "neg-0-375": "-5.25px",
      "neg-0-25": "-3.5px",
      "0-125": "1.75px",
      "0-25": "3.5px",
      "0-375": "5.25px",
      "0-5": "7px",
      "0-625": "8.75px",
      "0-75": "10.5px",
      "0-875": "12.25px",
      "1-125": "15.75px",
      "1-143": "16px",
      "1-25": "17.5px",
      "1-5": "21px",
      "1-625": "22.75px",
      "1-75": "24.5px",
      "2-25": "31.5px",
      "2-5": "35px",
      "2-75": "38.5px",
      "12-5": "175px"
    },
    "sky": {
      "50": "#F0F9FF",
      "100": "#E0F2FE",
      "200": "#BAE6FD",
      "300": "#7DD3FC",
      "400": "#38BDF8",
      "500": "#0EA5E9",
      "600": "#0284C7",
      "700": "#0369A1",
      "800": "#075985",
      "900": "#0C4A6E",
      "950": "#082F49"
    },
    "slate": {
      "50": "#F8FAFC",
      "100": "#F1F5F9",
      "200": "#E2E8F0",
      "300": "#CBD5E1",
      "400": "#94A3B8",
      "500": "#64748B",
      "600": "#475569",
      "700": "#334155",
      "800": "#1E293B",
      "900": "#0F172A",
      "950": "#020617"
    },
    "stone": {
      "50": "#FAFAF9",
      "100": "#F5F5F4",
      "200": "#E7E5E4",
      "300": "#D6D3D1",
      "400": "#A8A29E",
      "500": "#78716C",
      "600": "#57534E",
      "700": "#44403C",
      "800": "#292524",
      "900": "#1C1917",
      "950": "#0C0A09"
    },
    "teal": {
      "50": "#F0FDFA",
      "100": "#CCFBF1",
      "200": "#99F6E4",
      "300": "#5EEAD4",
      "400": "#2DD4BF",
      "500": "#14B8A6",
      "600": "#0D9488",
      "700": "#0F766E",
      "800": "#115E59",
      "900": "#134E4A",
      "950": "#042F2E"
    },
    "violet": {
      "50": "#F5F3FF",
      "100": "#EDE9FE",
      "200": "#DDD6FE",
      "300": "#C4B5FD",
      "400": "#A78BFA",
      "500": "#8B5CF6",
      "600": "#7C3AED",
      "700": "#6D28D9",
      "800": "#5B21B6",
      "900": "#4C1D95",
      "950": "#2E1065"
    },
    "yellow": {
      "50": "#FEFCE8",
      "100": "#FEF9C3",
      "200": "#FEF08A",
      "300": "#FDE047",
      "400": "#FACC15",
      "500": "#EAB308",
      "600": "#CA8A04",
      "700": "#A16207",
      "800": "#854D0E",
      "900": "#713F12",
      "950": "#422006"
    },
    "zinc": {
      "50": "#FAFAFA",
      "100": "#F4F4F5",
      "200": "#E4E4E7",
      "300": "#D4D4D8",
      "400": "#A1A1AA",
      "500": "#71717A",
      "600": "#52525B",
      "700": "#3F3F46",
      "800": "#27272A",
      "900": "#18181B",
      "950": "#09090B"
    }
  },
  "semantic": {
    "anchor": {
      "gutter": "2px"
    },
    "content": {
      "border": {
        "radius": "6px"
      }
    },
    "disabled": {
      "opacity": "0.6"
    },
    "focus": {
      "ring": {
        "width": "1px",
        "color": "{primary.600}",
        "offset": "2px"
      }
    },
    "form": {
      "field": {
        "border": {
          "radius": "6px"
        },
        "focus": {
          "ring": {
            "width": "0px",
            "color": "transparent",
            "offset": "0px"
          }
        },
        "padding": {
          "x": "10.5px",
          "y": "7px"
        },
        "sm": {
          "font": {
            "size": "12.25px"
          },
          "padding": {
            "x": "8.75px",
            "y": "5.25px"
          }
        },
        "lg": {
          "font": {
            "size": "15.75px"
          },
          "padding": {
            "x": "12.25px",
            "y": "8.75px"
          }
        }
      }
    },
    "icon": {
      "size": "14px"
    },
    "list": {
      "gap": "2px",
      "padding": "3.5px 3.5px",
      "header": {
        "padding": "7px 14px 3.5px 14px"
      },
      "option": {
        "group": {
          "font": {
            "weight": "600"
          },
          "padding": "7px 10.5px"
        },
        "border": {
          "radius": "4px"
        },
        "padding": "7px 10.5px"
      }
    },
    "navigation": {
      "item": {
        "gap": "7px",
        "padding": "7px 10.5px",
        "border": {
          "radius": "4px"
        }
      },
      "submenu": {
        "label": {
          "padding": "7px 10.5px",
          "font": {
            "weight": "600"
          }
        },
        "icon": {
          "size": "12.25px"
        }
      },
      "list": {
        "gap": "2px",
        "padding": "3.5px 3.5px"
      }
    },
    "overlay": {
      "select": {
        "border": {
          "radius": "6px"
        }
      },
      "popover": {
        "padding": "10.5px",
        "border": {
          "radius": "6px"
        }
      },
      "modal": {
        "padding": "17.5px",
        "border": {
          "radius": "12px"
        }
      },
      "title": {
        "font": {
          "size": "21px"
        }
      }
    },
    "primary": {
      "50": "#E8F8FB",
      "100": "#CFEFF6",
      "200": "#8DCBE2",
      "300": "#6CB7D7",
      "400": "#4BA3CD",
      "500": "#248DC1",
      "600": "#0284C7",
      "700": "#2175A0",
      "800": "#195C7D",
      "900": "#175270",
      "950": "#CB6015"
    },
    "colorScheme": {
      "light": {
        "content": {
          "background": "{surface.0}",
          "color": "{text.color}",
          "hover": {
            "background": "{surface.100}",
            "color": "{text.hover.color}"
          },
          "border": {
            "color": "{surface.200}"
          }
        },
        "form": {
          "field": {
            "background": "{surface.0}",
            "color": "{surface.700}",
            "disabled": {
              "background": "{surface.200}",
              "color": "{surface.600}"
            },
            "filled": {
              "background": "{surface.50}",
              "focus": {
                "background": "{surface.50}"
              },
              "hover": {
                "background": "{surface.50}"
              }
            },
            "border": {
              "color": "{surface.300}"
            },
            "hover": {
              "border": {
                "color": "{surface.400}"
              }
            },
            "focus": {
              "border": {
                "color": "{primary.color}"
              }
            },
            "invalid": {
              "border": {
                "color": "#F87171"
              },
              "placeholder": {
                "color": "#DC2626"
              }
            },
            "placeholder": {
              "color": "{surface.500}"
            },
            "float": {
              "label": {
                "color": "{surface.500}",
                "focus": {
                  "color": "{surface.500}"
                },
                "invalid": {
                  "color": "{form.field.invalid.placeholder.color}"
                },
                "active": {
                  "color": "{surface.500}"
                }
              }
            },
            "icon": {
              "color": "{surface.400}"
            }
          }
        },
        "highlight": {
          "background": "#E8F8FB",
          "color": "#2175A0",
          "focus": {
            "background": "#CFEFF6",
            "color": "#195C7D"
          }
        },
        "list": {
          "option": {
            "color": "{text.color}",
            "focus": {
              "background": "{surface.100}",
              "color": "{text.hover.color}"
            },
            "selected": {
              "background": "{highlight.background}",
              "color": "{highlight.color}",
              "focus": {
                "background": "{highlight.focus.background}",
                "color": "{highlight.focus.color}"
              }
            },
            "icon": {
              "color": "{surface.400}",
              "focus": {
                "color": "{surface.500}"
              }
            },
            "group": {
              "background": "transparent",
              "color": "{text.muted.color}"
            }
          }
        },
        "mask": {
          "background": "rgba(0, 0, 0, 0.1)",
          "color": "{surface.200}"
        },
        "navigation": {
          "item": {
            "color": "{text.color}",
            "focus": {
              "background": "{surface.100}",
              "color": "{text.hover.color}"
            },
            "active": {
              "background": "{surface.100}",
              "color": "{text.hover.color}"
            },
            "icon": {
              "color": "{surface.400}",
              "focus": {
                "color": "{surface.500}"
              },
              "active": {
                "color": "{surface.500}"
              }
            }
          },
          "submenu": {
            "label": {
              "background": "transparent",
              "color": "{text.muted.color}"
            },
            "icon": {
              "color": "{surface.400}",
              "focus": {
                "color": "{surface.500}"
              },
              "active": {
                "color": "{surface.500}"
              }
            }
          }
        },
        "overlay": {
          "select": {
            "background": "{surface.0}",
            "color": "{text.color}",
            "border": {
              "color": "{surface.200}"
            }
          },
          "popover": {
            "background": "{surface.0}",
            "color": "{text.color}",
            "border": {
              "color": "{surface.200}"
            }
          },
          "modal": {
            "background": "{surface.0}",
            "color": "{text.color}",
            "border": {
              "color": "{surface.200}"
            }
          }
        },
        "primary": {
          "color": "#2175A0",
          "contrast": {
            "color": "#FFFFFF"
          },
          "hover": {
            "color": "#0284C7"
          },
          "active": {
            "color": "#2175A0"
          }
        },
        "surface": {
          "0": "#FFFFFF",
          "50": "#F8FAFC",
          "100": "#F1F5F9",
          "200": "#E2E8F0",
          "300": "#CBD5E1",
          "400": "#94A3B8",
          "500": "#64748B",
          "600": "#475569",
          "700": "#334155",
          "800": "#1E293B",
          "900": "#0F172A",
          "950": "#020617"
        },
        "text": {
          "color": "{surface.700}",
          "hover": {
            "color": "{surface.800}",
            "muted": {
              "color": "{surface.600}"
            }
          },
          "muted": {
            "color": "{surface.500}"
          }
        }
      },
      "dark": {
        "content": {
          "background": "{surface.900}",
          "color": "{text.color}",
          "hover": {
            "background": "{surface.800}",
            "color": "{text.hover.color}"
          },
          "border": {
            "color": "{surface.700}"
          }
        },
        "form": {
          "field": {
            "background": "{surface.950}",
            "color": "{surface.0}",
            "disabled": {
              "background": "{surface.700}",
              "color": "{surface.400}"
            },
            "filled": {
              "background": "{surface.800}",
              "focus": {
                "background": "{surface.800}"
              },
              "hover": {
                "background": "{surface.800}"
              }
            },
            "border": {
              "color": "{surface.600}"
            },
            "hover": {
              "border": {
                "color": "{surface.500}"
              }
            },
            "focus": {
              "border": {
                "color": "{primary.color}"
              }
            },
            "invalid": {
              "border": {
                "color": "#FCA5A5"
              },
              "placeholder": {
                "color": "#F87171"
              }
            },
            "placeholder": {
              "color": "{surface.400}"
            },
            "float": {
              "label": {
                "color": "{surface.400}",
                "focus": {
                  "color": "{surface.400}"
                },
                "invalid": {
                  "color": "{form.field.invalid.placeholder.color}"
                },
                "active": {
                  "color": "{surface.400}"
                }
              }
            },
            "icon": {
              "color": "{surface.400}"
            }
          }
        },
        "highlight": {
          "background": "rgba(52, 211, 153, 0.16)",
          "color": "rgba(255, 255, 255, 0.87)",
          "focus": {
            "background": "rgba(52, 211, 153, 0.24)",
            "color": "rgba(255, 255, 255, 0.87)"
          }
        },
        "list": {
          "option": {
            "color": "{text.color}",
            "focus": {
              "background": "{surface.800}",
              "color": "{text.hover.color}"
            },
            "selected": {
              "background": "{highlight.background}",
              "color": "{highlight.color}",
              "focus": {
                "background": "{highlight.focus.background}",
                "color": "{highlight.focus.color}"
              }
            },
            "icon": {
              "color": "{surface.500}",
              "focus": {
                "color": "{surface.400}"
              }
            },
            "group": {
              "background": "transparent",
              "color": "{text.muted.color}"
            }
          }
        },
        "mask": {
          "background": "rgba(0, 0, 0, 0.6)",
          "color": "{surface.200}"
        },
        "navigation": {
          "item": {
            "color": "{text.color}",
            "focus": {
              "background": "{surface.800}",
              "color": "{text.hover.color}"
            },
            "active": {
              "background": "{surface.800}",
              "color": "{text.hover.color}"
            },
            "icon": {
              "color": "{surface.500}",
              "focus": {
                "color": "{surface.400}"
              },
              "active": {
                "color": "{surface.400}"
              }
            }
          },
          "submenu": {
            "label": {
              "background": "transparent",
              "color": "{text.muted.color}"
            },
            "icon": {
              "color": "{surface.500}",
              "focus": {
                "color": "{surface.400}"
              },
              "active": {
                "color": "{surface.400}"
              }
            }
          }
        },
        "overlay": {
          "select": {
            "background": "{surface.900}",
            "color": "{text.color}",
            "border": {
              "color": "{surface.700}"
            }
          },
          "popover": {
            "background": "{surface.900}",
            "color": "{text.color}",
            "border": {
              "color": "{surface.700}"
            }
          },
          "modal": {
            "background": "{surface.900}",
            "color": "{text.color}",
            "border": {
              "color": "{surface.700}"
            }
          }
        },
        "primary": {
          "color": "#4BA3CD",
          "contrast": {
            "color": "{surface.900}"
          },
          "hover": {
            "color": "#6CB7D7"
          },
          "active": {
            "color": "#8DCBE2"
          }
        },
        "surface": {
          "0": "#FFFFFF",
          "50": "#FAFAFA",
          "100": "#F4F4F5",
          "200": "#E4E4E7",
          "300": "#D4D4D8",
          "400": "#A1A1AA",
          "500": "#71717A",
          "600": "#52525B",
          "700": "#3F3F46",
          "800": "#27272A",
          "900": "#18181B",
          "950": "#09090B"
        },
        "text": {
          "color": "{surface.0}",
          "hover": {
            "color": "{surface.0}",
            "muted": {
              "color": "{surface.300}"
            }
          },
          "muted": {
            "color": "{surface.400}"
          }
        }
      }
    }
  },
  "components": {
    "accordion": {
      "panel": {
        "border": {
          "width": "1px",
          "color": "#E2E8F0"
        }
      },
      "header": {
        "color": "#64748B",
        "padding": "15.75px",
        "background": "#FFFFFF",
        "hover": {
          "color": "#334155",
          "background": "#FFFFFF"
        },
        "active": {
          "color": "#334155",
          "background": "#FFFFFF",
          "hover": {
            "background": "#FFFFFF",
            "color": "#334155"
          }
        },
        "font": {
          "weight": "600"
        },
        "border": {
          "radius": "0px",
          "width": "0px",
          "color": "#E2E8F0"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "color": "#0284C7",
            "offset": "2px"
          }
        },
        "toggle": {
          "icon": {
            "color": "#64748B",
            "hover": {
              "color": "#334155"
            },
            "active": {
              "color": "#334155",
              "hover": {
                "color": "#334155"
              }
            }
          }
        },
        "first": {
          "top": {
            "border": {
              "radius": "6px"
            }
          },
          "border": {
            "width": "0px"
          }
        },
        "last": {
          "bottom": {
            "border": {
              "radius": "6px"
            }
          },
          "active": {
            "bottom": {
              "border": {
                "radius": "0px"
              }
            }
          }
        }
      },
      "content": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "width": "0px",
          "color": "#E2E8F0"
        },
        "padding": "0px 15.75px 15.75px 15.75px"
      }
    },
    "autocomplete": {
      "background": "#FFFFFF",
      "color": "#334155",
      "dropdown": {
        "width": "35px",
        "hover": {
          "border": {
            "color": "#CBD5E1"
          }
        },
        "active": {
          "border": {
            "color": "#CBD5E1"
          }
        },
        "border": {
          "color": "#CBD5E1",
          "radius": "6px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "2px",
            "color": "#0284C7"
          }
        },
        "sm": {
          "width": "28px"
        },
        "lg": {
          "width": "42px"
        }
      },
      "chip": {
        "border": {
          "radius": "4px"
        }
      },
      "disabled": {
        "background": "#E2E8F0",
        "color": "#475569"
      },
      "filled": {
        "background": "#F8FAFC",
        "focus": {
          "background": "#F8FAFC"
        },
        "hover": {
          "background": "#F8FAFC"
        }
      },
      "border": {
        "color": "#CBD5E1",
        "radius": "6px"
      },
      "hover": {
        "border": {
          "color": "#94A3B8"
        }
      },
      "focus": {
        "border": {
          "color": "#2175A0"
        },
        "ring": {
          "width": "0px",
          "color": "transparent",
          "offset": "0px"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        },
        "placeholder": {
          "color": "#DC2626"
        }
      },
      "placeholder": {
        "color": "#64748B"
      },
      "padding": {
        "x": "10.5px",
        "y": "7px"
      },
      "overlay": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        }
      },
      "list": {
        "gap": "2px",
        "padding": "3.5px 3.5px"
      },
      "option": {
        "color": "#334155",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#E8F8FB",
          "color": "#2175A0",
          "focus": {
            "background": "#CFEFF6",
            "color": "#195C7D"
          }
        },
        "border": {
          "radius": "4px"
        },
        "group": {
          "background": "transparent",
          "color": "#64748B",
          "font": {
            "weight": "600"
          },
          "padding": "7px 10.5px"
        },
        "padding": "7px 10.5px"
      },
      "colorScheme": {
        "light": {
          "dropdown": {
            "background": "#F1F5F9",
            "color": "#475569",
            "hover": {
              "background": "#E2E8F0",
              "color": "#334155"
            },
            "active": {
              "background": "#CBD5E1",
              "color": "#1E293B"
            }
          },
          "chip": {
            "focus": {
              "background": "#E2E8F0",
              "color": "#1E293B"
            }
          }
        },
        "dark": {
          "dropdown": {
            "background": "#1E293B",
            "color": "#CBD5E1",
            "hover": {
              "background": "#334155",
              "color": "#E2E8F0"
            },
            "active": {
              "background": "#475569",
              "color": "#F1F5F9"
            }
          },
          "chip": {
            "focus": {
              "background": "#334155",
              "color": "#FFFFFF"
            }
          }
        }
      }
    },
    "avatar": {
      "width": "28px",
      "height": "28px",
      "background": "#E2E8F0",
      "color": "#334155",
      "font": {
        "size": "14px"
      },
      "border": {
        "radius": "6px"
      },
      "group": {
        "offset": "-10.5px",
        "border": {
          "color": "#FFFFFF"
        }
      },
      "lg": {
        "width": "42px",
        "height": "42px",
        "font": {
          "size": "21px"
        },
        "icon": {
          "size": "21px"
        },
        "group": {
          "offset": "-14px"
        }
      },
      "xl": {
        "width": "56px",
        "height": "56px",
        "font": {
          "size": "28px"
        },
        "icon": {
          "size": "28px"
        },
        "group": {
          "offset": "-21px"
        }
      },
      "icon": {
        "size": "14px"
      }
    },
    "badge": {
      "height": "21px",
      "padding": "0px 7px",
      "border": {
        "radius": "6px"
      },
      "font": {
        "size": "10.5px",
        "weight": "700"
      },
      "min": {
        "width": "21px"
      },
      "dot": {
        "size": "7px"
      },
      "sm": {
        "height": "17.5px",
        "font": {
          "size": "8.75px"
        },
        "min": {
          "width": "17.5px"
        }
      },
      "lg": {
        "height": "24.5px",
        "font": {
          "size": "12.25px"
        },
        "min": {
          "width": "24.5px"
        }
      },
      "xl": {
        "height": "28px",
        "font": {
          "size": "14px"
        },
        "min": {
          "width": "28px"
        }
      },
      "colorScheme": {
        "light": {
          "primary": {
            "background": "#2175A0",
            "color": "#FFFFFF"
          },
          "secondary": {
            "background": "#F1F5F9",
            "color": "#475569"
          },
          "success": {
            "background": "#15803D",
            "color": "#FFFFFF"
          },
          "info": {
            "background": "#2563EB",
            "color": "#FFFFFF"
          },
          "warn": {
            "background": "#C2410C",
            "color": "#FFFFFF"
          },
          "danger": {
            "background": "#B91C1C",
            "color": "#FFFFFF"
          },
          "contrast": {
            "background": "#020617",
            "color": "#FFFFFF"
          }
        },
        "dark": {
          "primary": {
            "background": "#2175A0",
            "color": "#FFFFFF"
          },
          "secondary": {
            "background": "#1E293B",
            "color": "#CBD5E1"
          },
          "success": {
            "background": "#4ADE80",
            "color": "#052E16"
          },
          "info": {
            "background": "#38BDF8",
            "color": "#082F49"
          },
          "warn": {
            "background": "#FB923C",
            "color": "#020617"
          },
          "danger": {
            "background": "#F87171",
            "color": "#450A0A"
          },
          "contrast": {
            "background": "#FFFFFF",
            "color": "#020617"
          }
        }
      }
    },
    "blockui": {
      "border": {
        "radius": "6px"
      }
    },
    "breadcrumb": {
      "padding": "14px",
      "background": "#FFFFFF",
      "gap": "7px",
      "item": {
        "color": "#64748B",
        "gap": "7px",
        "hover": {
          "color": "#334155"
        },
        "icon": {
          "color": "#94A3B8",
          "hover": {
            "color": "#64748B"
          }
        },
        "border": {
          "radius": "6px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "color": "#0284C7",
            "offset": "2px"
          }
        }
      },
      "separator": {
        "color": "#94A3B8"
      }
    },
    "button": {
      "gap": "7px",
      "border": {
        "radius": "6px"
      },
      "rounded": {
        "border": {
          "radius": "28px"
        }
      },
      "padding": {
        "x": "10.5px",
        "y": "7px"
      },
      "icon": {
        "only": {
          "width": "35px"
        }
      },
      "sm": {
        "font": {
          "size": "12.25px"
        },
        "icon": {
          "only": {
            "width": "28px"
          }
        },
        "padding": {
          "x": "8.75px",
          "y": "5.25px"
        }
      },
      "lg": {
        "font": {
          "size": "15.75px"
        },
        "padding": {
          "x": "12.25px",
          "y": "8.75px"
        },
        "icon": {
          "only": {
            "width": "42px"
          }
        }
      },
      "label": {
        "font": {
          "weight": "500"
        }
      },
      "focus": {
        "ring": {
          "width": "1px",
          "offset": "2px"
        }
      },
      "colorScheme": {
        "light": {
          "primary": {
            "background": "#2175A0",
            "color": "#FFFFFF",
            "hover": {
              "background": "#195C7D",
              "color": "#FFFFFF",
              "border": {
                "color": "#248DC1"
              }
            },
            "active": {
              "background": "#175270",
              "color": "#FFFFFF",
              "border": {
                "color": "#175270"
              }
            },
            "border": {
              "color": "#2175A0"
            },
            "focus": {
              "ring": {
                "color": "#4BA3CD"
              }
            }
          },
          "secondary": {
            "color": "#2175A0",
            "hover": {
              "background": "#E8F8FB",
              "color": "#2175A0",
              "border": {
                "color": "#8DCBE2"
              }
            },
            "active": {
              "background": "#CFEFF6",
              "color": "#195C7D",
              "border": {
                "color": "#4BA3CD"
              }
            },
            "border": {
              "color": "#8DCBE2"
            },
            "focus": {
              "ring": {
                "color": "#4BA3CD"
              }
            }
          },
          "info": {
            "background": "#0EA5E9",
            "color": "#FFFFFF",
            "hover": {
              "background": "#0284C7",
              "color": "#FFFFFF",
              "border": {
                "color": "#0284C7"
              }
            },
            "active": {
              "background": "#0369A1",
              "color": "#FFFFFF",
              "border": {
                "color": "#0369A1"
              }
            },
            "border": {
              "color": "#0EA5E9"
            },
            "focus": {
              "ring": {
                "color": "#0EA5E9"
              }
            }
          },
          "success": {
            "background": "#15803D",
            "color": "#FFFFFF",
            "hover": {
              "background": "#166534",
              "color": "#FFFFFF",
              "border": {
                "color": "#16A34A"
              }
            },
            "active": {
              "background": "#14532D",
              "color": "#FFFFFF",
              "border": {
                "color": "#14532D"
              }
            },
            "border": {
              "color": "#15803D"
            },
            "focus": {
              "ring": {
                "color": "#22C55E"
              }
            }
          },
          "warn": {
            "background": "#F97316",
            "color": "#FFFFFF",
            "hover": {
              "background": "#EA580C",
              "color": "#FFFFFF",
              "border": {
                "color": "#EA580C"
              }
            },
            "active": {
              "background": "#C2410C",
              "color": "#FFFFFF",
              "border": {
                "color": "#C2410C"
              }
            },
            "border": {
              "color": "#F97316"
            },
            "focus": {
              "ring": {
                "color": "#F97316"
              }
            }
          },
          "help": {
            "background": "#A855F7",
            "color": "#FFFFFF",
            "hover": {
              "background": "#9333EA",
              "color": "#FFFFFF",
              "border": {
                "color": "#9333EA"
              }
            },
            "active": {
              "background": "#7E22CE",
              "color": "#FFFFFF",
              "border": {
                "color": "#7E22CE"
              }
            },
            "border": {
              "color": "#A855F7"
            },
            "focus": {
              "ring": {
                "color": "#A855F7"
              }
            }
          },
          "danger": {
            "background": "#B91C1C",
            "color": "#FFFFFF",
            "hover": {
              "background": "#991B1B",
              "color": "#FFFFFF",
              "border": {
                "color": "#DC2626"
              }
            },
            "active": {
              "background": "#7F1D1D",
              "color": "#FFFFFF",
              "border": {
                "color": "#7F1D1D"
              }
            },
            "border": {
              "color": "#B91C1C"
            },
            "focus": {
              "ring": {
                "color": "#EF4444"
              }
            }
          },
          "contrast": {
            "background": "#020617",
            "color": "#FFFFFF",
            "hover": {
              "background": "#0F172A",
              "color": "#FFFFFF",
              "border": {
                "color": "#0F172A"
              }
            },
            "active": {
              "background": "#1E293B",
              "color": "#FFFFFF",
              "border": {
                "color": "#1E293B"
              }
            },
            "border": {
              "color": "#020617"
            },
            "focus": {
              "ring": {
                "color": "#020617"
              }
            }
          },
          "outlined": {
            "primary": {
              "color": "#2175A0",
              "hover": {
                "background": "#E8F8FB"
              },
              "active": {
                "background": "#CFEFF6"
              },
              "border": {
                "color": "#8DCBE2"
              }
            },
            "secondary": {
              "color": "#64748B",
              "hover": {
                "background": "#F8FAFC"
              },
              "active": {
                "background": "#F1F5F9"
              },
              "border": {
                "color": "#E2E8F0"
              }
            },
            "success": {
              "color": "#22C55E",
              "hover": {
                "background": "#F0FDF4"
              },
              "active": {
                "background": "#DCFCE7"
              },
              "border": {
                "color": "#BBF7D0"
              }
            },
            "info": {
              "color": "#0EA5E9",
              "hover": {
                "background": "#F0F9FF"
              },
              "active": {
                "background": "#E0F2FE"
              },
              "border": {
                "color": "#BAE6FD"
              }
            },
            "warn": {
              "color": "#F97316",
              "hover": {
                "background": "#FFF7ED"
              },
              "active": {
                "background": "#FFEDD5"
              },
              "border": {
                "color": "#FED7AA"
              }
            },
            "help": {
              "color": "#A855F7",
              "hover": {
                "background": "#FAF5FF"
              },
              "active": {
                "background": "#F3E8FF"
              },
              "border": {
                "color": "#E9D5FF"
              }
            },
            "danger": {
              "color": "#EF4444",
              "hover": {
                "background": "#FEF2F2"
              },
              "active": {
                "background": "#FEE2E2"
              },
              "border": {
                "color": "#FECACA"
              }
            },
            "contrast": {
              "color": "#020617",
              "hover": {
                "background": "#F8FAFC"
              },
              "active": {
                "background": "#F1F5F9"
              },
              "border": {
                "color": "#334155"
              }
            },
            "plain": {
              "color": "#334155",
              "hover": {
                "background": "#F8FAFC"
              },
              "active": {
                "background": "#F1F5F9"
              },
              "border": {
                "color": "#E2E8F0"
              }
            }
          },
          "text": {
            "primary": {
              "color": "#2175A0",
              "hover": {
                "background": "#E8F8FB"
              },
              "active": {
                "background": "#CFEFF6"
              }
            },
            "secondary": {
              "color": "#64748B",
              "hover": {
                "background": "#F8FAFC"
              },
              "active": {
                "background": "#F1F5F9"
              }
            },
            "success": {
              "color": "#22C55E",
              "hover": {
                "background": "#F0FDF4"
              },
              "active": {
                "background": "#DCFCE7"
              }
            },
            "info": {
              "color": "#0EA5E9",
              "hover": {
                "background": "#F0F9FF"
              },
              "active": {
                "background": "#E0F2FE"
              }
            },
            "warn": {
              "color": "#F97316",
              "hover": {
                "background": "#FFF7ED"
              },
              "active": {
                "background": "#FFEDD5"
              }
            },
            "help": {
              "color": "#A855F7",
              "hover": {
                "background": "#FAF5FF"
              },
              "active": {
                "background": "#F3E8FF"
              }
            },
            "danger": {
              "color": "#EF4444",
              "hover": {
                "background": "#FEF2F2"
              },
              "active": {
                "background": "#FEE2E2"
              }
            },
            "plain": {
              "color": "#334155",
              "hover": {
                "background": "#F8FAFC"
              },
              "active": {
                "background": "#F1F5F9"
              }
            },
            "contrast": {
              "color": "#020617",
              "hover": {
                "background": "#F8FAFC"
              },
              "active": {
                "background": "#F1F5F9"
              }
            }
          },
          "link": {
            "color": "#2175A0",
            "hover": {
              "color": "#2175A0"
            },
            "active": {
              "color": "#2175A0"
            }
          },
          "figma": {
            "raised": {
              "background": "rgba(255, 255, 255, 0.01)"
            }
          }
        },
        "dark": {
          "primary": {
            "background": "#2175A0",
            "color": "#FFFFFF",
            "hover": {
              "background": "#0284C7",
              "color": "#FFFFFF",
              "border": {
                "color": "#0284C7"
              }
            },
            "active": {
              "background": "#2175A0",
              "color": "#FFFFFF",
              "border": {
                "color": "#2175A0"
              }
            },
            "border": {
              "color": "#2175A0"
            },
            "focus": {
              "ring": {
                "color": "#2175A0"
              }
            }
          },
          "secondary": {
            "color": "#CBD5E1",
            "hover": {
              "background": "#334155",
              "color": "#E2E8F0",
              "border": {
                "color": "#334155"
              }
            },
            "active": {
              "background": "#475569",
              "color": "#F1F5F9",
              "border": {
                "color": "#475569"
              }
            },
            "border": {
              "color": "#1E293B"
            },
            "focus": {
              "ring": {
                "color": "#CBD5E1"
              }
            }
          },
          "info": {
            "background": "#38BDF8",
            "color": "#082F49",
            "hover": {
              "background": "#7DD3FC",
              "color": "#082F49",
              "border": {
                "color": "#7DD3FC"
              }
            },
            "active": {
              "background": "#BAE6FD",
              "color": "#082F49",
              "border": {
                "color": "#BAE6FD"
              }
            },
            "border": {
              "color": "#38BDF8"
            },
            "focus": {
              "ring": {
                "color": "#38BDF8"
              }
            }
          },
          "success": {
            "background": "#4ADE80",
            "color": "#052E16",
            "hover": {
              "background": "#86EFAC",
              "color": "#052E16",
              "border": {
                "color": "#86EFAC"
              }
            },
            "active": {
              "background": "#BBF7D0",
              "color": "#052E16",
              "border": {
                "color": "#BBF7D0"
              }
            },
            "border": {
              "color": "#4ADE80"
            },
            "focus": {
              "ring": {
                "color": "#4ADE80"
              }
            }
          },
          "warn": {
            "background": "#FB923C",
            "color": "#431407",
            "hover": {
              "background": "#FDBA74",
              "color": "#431407",
              "border": {
                "color": "#FDBA74"
              }
            },
            "active": {
              "background": "#FED7AA",
              "color": "#431407",
              "border": {
                "color": "#FED7AA"
              }
            },
            "border": {
              "color": "#FB923C"
            },
            "focus": {
              "ring": {
                "color": "#FB923C"
              }
            }
          },
          "help": {
            "background": "#C084FC",
            "color": "#3B0764",
            "hover": {
              "background": "#D8B4FE",
              "color": "#3B0764",
              "border": {
                "color": "#D8B4FE"
              }
            },
            "active": {
              "background": "#E9D5FF",
              "color": "#3B0764",
              "border": {
                "color": "#E9D5FF"
              }
            },
            "border": {
              "color": "#C084FC"
            },
            "focus": {
              "ring": {
                "color": "#C084FC"
              }
            }
          },
          "danger": {
            "background": "#F87171",
            "color": "#450A0A",
            "hover": {
              "background": "#FCA5A5",
              "color": "#450A0A",
              "border": {
                "color": "#FCA5A5"
              }
            },
            "active": {
              "background": "#FECACA",
              "color": "#450A0A",
              "border": {
                "color": "#FECACA"
              }
            },
            "border": {
              "color": "#F87171"
            },
            "focus": {
              "ring": {
                "color": "#F87171"
              }
            }
          },
          "contrast": {
            "background": "#FFFFFF",
            "color": "#020617",
            "hover": {
              "background": "#F1F5F9",
              "color": "#020617",
              "border": {
                "color": "#F1F5F9"
              }
            },
            "active": {
              "background": "#E2E8F0",
              "color": "#020617",
              "border": {
                "color": "#E2E8F0"
              }
            },
            "border": {
              "color": "#FFFFFF"
            },
            "focus": {
              "ring": {
                "color": "#FFFFFF"
              }
            }
          },
          "outlined": {
            "primary": {
              "color": "#2175A0",
              "hover": {
                "background": "rgba(52, 211, 153, 0.04)"
              },
              "active": {
                "background": "rgba(52, 211, 153, 0.16)"
              },
              "border": {
                "color": "#2175A0"
              }
            },
            "secondary": {
              "color": "#94A3B8",
              "hover": {
                "background": "rgba(255, 255, 255, 0.04)"
              },
              "active": {
                "background": "rgba(255, 255, 255, 0.16)"
              },
              "border": {
                "color": "#334155"
              }
            },
            "success": {
              "color": "#4ADE80",
              "hover": {
                "background": "rgba(74, 222, 128, 0.04)"
              },
              "active": {
                "background": "rgba(74, 222, 128, 0.16)"
              },
              "border": {
                "color": "{green.700}"
              }
            },
            "info": {
              "color": "#38BDF8",
              "hover": {
                "background": "rgba(56, 189, 248, 0.04)"
              },
              "active": {
                "background": "rgba(56, 189, 248, 0.16)"
              },
              "border": {
                "color": "#0369A1"
              }
            },
            "warn": {
              "color": "#FB923C",
              "hover": {
                "background": "rgba(251, 146, 60, 0.04)"
              },
              "active": {
                "background": "rgba(251, 146, 60, 0.16)"
              },
              "border": {
                "color": "#C2410C"
              }
            },
            "help": {
              "color": "#C084FC",
              "hover": {
                "background": "rgba(192, 132, 252, 0.04)"
              },
              "active": {
                "background": "rgba(192, 132, 252, 0.16)"
              },
              "border": {
                "color": "#7E22CE"
              }
            },
            "danger": {
              "color": "#F87171",
              "hover": {
                "background": "rgba(248, 113, 113, 0.04)"
              },
              "active": {
                "background": "rgba(248, 113, 113, 0.16)"
              },
              "border": {
                "color": "#B91C1C"
              }
            },
            "contrast": {
              "color": "#FFFFFF",
              "hover": {
                "background": "#1E293B"
              },
              "active": {
                "background": "#334155"
              },
              "border": {
                "color": "#64748B"
              }
            },
            "plain": {
              "color": "#FFFFFF",
              "hover": {
                "background": "#1E293B"
              },
              "active": {
                "background": "#334155"
              },
              "border": {
                "color": "#475569"
              }
            }
          },
          "text": {
            "primary": {
              "color": "#2175A0",
              "hover": {
                "background": "rgba(52, 211, 153, 0.04)"
              },
              "active": {
                "background": "rgba(52, 211, 153, 0.16)"
              }
            },
            "secondary": {
              "color": "#94A3B8",
              "hover": {
                "background": "#1E293B"
              },
              "active": {
                "background": "#334155"
              }
            },
            "success": {
              "color": "#4ADE80",
              "hover": {
                "background": "rgba(74, 222, 128, 0.04)"
              },
              "active": {
                "background": "rgba(74, 222, 128, 0.16)"
              }
            },
            "info": {
              "color": "#38BDF8",
              "hover": {
                "background": "rgba(56, 189, 248, 0.04)"
              },
              "active": {
                "background": "rgba(56, 189, 248, 0.16)"
              }
            },
            "warn": {
              "color": "#FB923C",
              "hover": {
                "background": "rgba(251, 146, 60, 0.04)"
              },
              "active": {
                "background": "rgba(251, 146, 60, 0.16)"
              }
            },
            "help": {
              "color": "#C084FC",
              "hover": {
                "background": "rgba(192, 132, 252, 0.04)"
              },
              "active": {
                "background": "rgba(192, 132, 252, 0.16)"
              }
            },
            "danger": {
              "color": "#F87171",
              "hover": {
                "background": "rgba(248, 113, 113, 0.04)"
              },
              "active": {
                "background": "rgba(248, 113, 113, 0.16)"
              }
            },
            "plain": {
              "color": "#FFFFFF",
              "hover": {
                "background": "#1E293B"
              },
              "active": {
                "background": "#334155"
              }
            },
            "contrast": {
              "color": "#FFFFFF",
              "hover": {
                "background": "#1E293B"
              },
              "active": {
                "background": "#334155"
              }
            }
          },
          "link": {
            "color": "#2175A0",
            "hover": {
              "color": "#2175A0"
            },
            "active": {
              "color": "#2175A0"
            }
          },
          "figma": {
            "raised": {
              "background": "rgba(0, 0, 0, 0.01)"
            }
          }
        }
      }
    },
    "card": {
      "background": "#FFFFFF",
      "color": "#334155",
      "border": {
        "radius": "12px"
      },
      "body": {
        "padding": "17.5px",
        "gap": "7px"
      },
      "caption": {
        "gap": "7px"
      },
      "title": {
        "font": {
          "size": "17.5px",
          "weight": "500"
        }
      },
      "subtitle": {
        "color": "#64748B"
      }
    },
    "carousel": {
      "indicator": {
        "width": "28px",
        "height": "7px",
        "active": {
          "background": "#2175A0"
        },
        "list": {
          "padding": "14px",
          "gap": "7px"
        },
        "border": {
          "radius": "6px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "2px",
            "color": "#0284C7"
          }
        }
      },
      "content": {
        "gap": "3.5px"
      },
      "colorScheme": {
        "light": {
          "indicator": {
            "background": "#E2E8F0",
            "hover": {
              "background": "#CBD5E1"
            }
          },
          "figma": {
            "item": {
              "tag": {
                "background": "transparent"
              }
            }
          }
        },
        "dark": {
          "indicator": {
            "background": "#334155",
            "hover": {
              "background": "#475569"
            }
          },
          "figma": {
            "item": {
              "tag": {
                "background": "rgba(0, 0, 0, 0.7)"
              }
            }
          }
        }
      }
    },
    "cascadeselect": {
      "background": "#FFFFFF",
      "color": "#334155",
      "disabled": {
        "background": "#E2E8F0",
        "color": "#475569"
      },
      "filled": {
        "background": "#F8FAFC",
        "focus": {
          "background": "#F8FAFC"
        },
        "hover": {
          "background": "#F8FAFC"
        }
      },
      "border": {
        "color": "#CBD5E1",
        "radius": "6px"
      },
      "hover": {
        "border": {
          "color": "#94A3B8"
        }
      },
      "focus": {
        "border": {
          "color": "#2175A0"
        },
        "ring": {
          "width": "0px",
          "color": "transparent",
          "offset": "0px"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        },
        "placeholder": {
          "color": "#DC2626"
        }
      },
      "placeholder": {
        "color": "#64748B"
      },
      "padding": {
        "x": "10.5px",
        "y": "7px"
      },
      "dropdown": {
        "width": "35px",
        "color": "#94A3B8"
      },
      "overlay": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        }
      },
      "list": {
        "gap": "2px",
        "padding": "3.5px 3.5px",
        "mobile": {
          "indent": "14px"
        }
      },
      "option": {
        "color": "#334155",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#E8F8FB",
          "color": "#2175A0",
          "focus": {
            "background": "#CFEFF6",
            "color": "#195C7D"
          }
        },
        "border": {
          "radius": "4px"
        },
        "icon": {
          "color": "#94A3B8",
          "size": "12.25px",
          "focus": {
            "color": "#64748B"
          }
        },
        "padding": "7px 10.5px"
      },
      "sm": {
        "font": {
          "size": "12.25px"
        },
        "padding": {
          "x": "8.75px",
          "y": "5.25px"
        }
      },
      "lg": {
        "font": {
          "size": "15.75px"
        },
        "padding": {
          "x": "12.25px",
          "y": "8.75px"
        }
      },
      "clear": {
        "icon": {
          "color": "#94A3B8"
        }
      }
    },
    "checkbox": {
      "width": "17.5px",
      "height": "17.5px",
      "background": "#FFFFFF",
      "border": {
        "radius": "4px",
        "color": "#CBD5E1"
      },
      "checked": {
        "background": "#2175A0",
        "hover": {
          "background": "#0284C7",
          "border": {
            "color": "#0284C7"
          }
        },
        "border": {
          "color": "#2175A0"
        },
        "focus": {
          "border": {
            "color": "#2175A0"
          }
        },
        "disabled": {
          "border": {
            "color": "#CBD5E1"
          }
        }
      },
      "disabled": {
        "background": "#E2E8F0"
      },
      "filled": {
        "background": "#F8FAFC"
      },
      "hover": {
        "border": {
          "color": "#94A3B8"
        }
      },
      "focus": {
        "border": {
          "color": "#CBD5E1"
        },
        "ring": {
          "width": "1px",
          "color": "#0284C7",
          "offset": "2px"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        }
      },
      "icon": {
        "size": "12.25px",
        "color": "#334155",
        "checked": {
          "color": "#FFFFFF",
          "hover": {
            "color": "#FFFFFF"
          }
        },
        "disabled": {
          "color": "#475569"
        },
        "sm": {
          "size": "10.5px"
        },
        "lg": {
          "size": "14px"
        }
      },
      "sm": {
        "width": "14px",
        "height": "14px"
      },
      "lg": {
        "width": "21px",
        "height": "21px"
      }
    },
    "chip": {
      "gap": "7px",
      "icon": {
        "size": "14px"
      },
      "remove": {
        "icon": {
          "size": "14px",
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "2px",
              "color": "#0284C7"
            }
          }
        }
      },
      "border": {
        "radius": "16px"
      },
      "padding": {
        "x": "10.5px",
        "y": "7px"
      },
      "image": {
        "width": "28px",
        "height": "28px"
      },
      "colorScheme": {
        "light": {
          "background": "#F1F5F9",
          "color": "#1E293B",
          "icon": {
            "color": "#1E293B"
          },
          "remove": {
            "icon": {
              "color": "#1E293B"
            }
          }
        },
        "dark": {
          "background": "#1E293B",
          "color": "#FFFFFF",
          "icon": {
            "color": "#FFFFFF"
          },
          "remove": {
            "icon": {
              "color": "#FFFFFF"
            }
          }
        }
      }
    },
    "colorpicker": {
      "panel": {
        "border": {
          "radius": "6px"
        }
      },
      "preview": {
        "width": "21px",
        "height": "21px",
        "border": {
          "radius": "6px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "color": "#0284C7",
            "offset": "2px"
          }
        }
      },
      "colorScheme": {
        "light": {
          "panel": {
            "background": "#1E293B",
            "border": {
              "color": "#0F172A"
            }
          },
          "handle": {
            "color": "#FFFFFF"
          }
        },
        "dark": {
          "panel": {
            "background": "#0F172A",
            "border": {
              "color": "#334155"
            }
          },
          "handle": {
            "color": "#FFFFFF"
          }
        }
      }
    },
    "confirmdialog": {
      "icon": {
        "size": "28px",
        "color": "#334155"
      },
      "content": {
        "gap": "14px"
      }
    },
    "confirmpopup": {
      "background": "#FFFFFF",
      "color": "#334155",
      "gutter": "10px",
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "arrow": {
        "offset": "17.5px"
      },
      "content": {
        "padding": "10.5px",
        "gap": "14px"
      },
      "icon": {
        "size": "21px",
        "color": "#334155"
      },
      "footer": {
        "gap": "7px",
        "padding": "0px 10.5px 10.5px 10.5px"
      }
    },
    "contextmenu": {
      "background": "#FFFFFF",
      "color": "#334155",
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "list": {
        "gap": "2px",
        "padding": "3.5px 3.5px"
      },
      "item": {
        "color": "#334155",
        "gap": "7px",
        "padding": "7px 10.5px",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "active": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "border": {
          "radius": "4px"
        },
        "icon": {
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          },
          "active": {
            "color": "#64748B"
          }
        }
      },
      "submenu": {
        "icon": {
          "size": "12.25px",
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          },
          "active": {
            "color": "#64748B"
          }
        },
        "mobile": {
          "indent": "14px"
        }
      },
      "separator": {
        "border": {
          "color": "#E2E8F0"
        }
      }
    },
    "datepicker": {
      "select": {
        "year": {
          "color": "#334155",
          "padding": "3.5px 7px",
          "hover": {
            "background": "#F1F5F9",
            "color": "#1E293B"
          },
          "border": {
            "radius": "6px"
          }
        },
        "month": {
          "color": "#334155",
          "hover": {
            "background": "#F1F5F9",
            "color": "#1E293B"
          },
          "border": {
            "radius": "6px"
          },
          "padding": "3.5px 7px"
        }
      },
      "year": {
        "padding": "5.25px",
        "view": {
          "margin": "7px 0px 0px 0px"
        },
        "border": {
          "radius": "6px"
        }
      },
      "dropdown": {
        "width": "35px",
        "hover": {
          "border": {
            "color": "#CBD5E1"
          }
        },
        "active": {
          "border": {
            "color": "#CBD5E1"
          }
        },
        "border": {
          "color": "#CBD5E1",
          "radius": "6px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "color": "#0284C7",
            "offset": "2px"
          }
        },
        "sm": {
          "width": "28px"
        },
        "lg": {
          "width": "42px"
        }
      },
      "panel": {
        "background": "#FFFFFF",
        "color": "#334155",
        "padding": "10.5px",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        }
      },
      "header": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "color": "#E2E8F0"
        },
        "padding": "0px 0px 7px 0px"
      },
      "title": {
        "gap": "7px",
        "font": {
          "weight": "500"
        }
      },
      "input": {
        "icon": {
          "color": "#94A3B8"
        }
      },
      "group": {
        "gap": "10.5px",
        "border": {
          "color": "#E2E8F0"
        }
      },
      "week": {
        "day": {
          "padding": "3.5px",
          "color": "#334155",
          "font": {
            "weight": "500"
          }
        }
      },
      "date": {
        "color": "#334155",
        "width": "28px",
        "height": "28px",
        "padding": "3.5px",
        "hover": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#2175A0",
          "color": "#FFFFFF"
        },
        "range": {
          "selected": {
            "background": "#E8F8FB",
            "color": "#2175A0"
          }
        },
        "border": {
          "radius": "14px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "color": "#0284C7",
            "offset": "2px"
          }
        }
      },
      "buttonbar": {
        "border": {
          "color": "#E2E8F0"
        },
        "padding": "7px 0px 0px 0px"
      },
      "time": {
        "picker": {
          "gap": "7px",
          "border": {
            "color": "#E2E8F0"
          },
          "button": {
            "gap": "3.5px"
          },
          "padding": "7px 0px 0px 0px"
        }
      },
      "month": {
        "padding": "5.25px",
        "border": {
          "radius": "6px"
        },
        "view": {
          "margin": "7px 0px 0px 0px"
        }
      },
      "day": {
        "view": {
          "margin": "7px 0px 0px 0px"
        }
      },
      "colorScheme": {
        "light": {
          "dropdown": {
            "background": "#F1F5F9",
            "color": "#475569",
            "hover": {
              "background": "#E2E8F0",
              "color": "#334155"
            },
            "active": {
              "background": "#CBD5E1",
              "color": "#1E293B"
            }
          },
          "today": {
            "background": "#E2E8F0",
            "color": "#0F172A"
          }
        },
        "dark": {
          "dropdown": {
            "background": "#1E293B",
            "color": "#CBD5E1",
            "hover": {
              "background": "#334155",
              "color": "#E2E8F0"
            },
            "active": {
              "background": "#475569",
              "color": "#F1F5F9"
            }
          },
          "today": {
            "background": "#334155",
            "color": "#FFFFFF"
          }
        }
      }
    },
    "datatable": {
      "header": {
        "background": "#FFFFFF",
        "color": "#334155",
        "lg": {
          "padding": "14px 17.5px"
        },
        "sm": {
          "padding": "5.25px 7px"
        },
        "padding": "10.5px 14px",
        "cell": {
          "background": "#FFFFFF",
          "color": "#334155",
          "gap": "7px",
          "padding": "10.5px 14px",
          "lg": {
            "padding": "14px 17.5px"
          },
          "sm": {
            "padding": "5.25px 7px"
          },
          "hover": {
            "background": "#F1F5F9",
            "color": "#1E293B"
          },
          "selected": {
            "background": "#E8F8FB",
            "color": "#2175A0"
          },
          "border": {
            "color": "#E2E8F0"
          },
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "-1px",
              "color": "#0284C7"
            }
          }
        },
        "border": {
          "color": "#E2E8F0",
          "width": "1px"
        }
      },
      "row": {
        "background": "#FFFFFF",
        "color": "#334155",
        "hover": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#E8F8FB",
          "color": "#2175A0"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "-1px",
            "color": "#0284C7"
          }
        },
        "toggle": {
          "button": {
            "color": "#64748B",
            "size": "24.5px",
            "hover": {
              "background": "#F1F5F9",
              "color": "#334155"
            },
            "selected": {
              "hover": {
                "background": "#FFFFFF",
                "color": "#2175A0"
              }
            },
            "border": {
              "radius": "12.25px"
            },
            "focus": {
              "ring": {
                "width": "1px",
                "offset": "2px",
                "color": "#0284C7"
              }
            }
          }
        }
      },
      "body": {
        "cell": {
          "border": {
            "color": "#E2E8F0"
          },
          "padding": "10.5px 14px",
          "sm": {
            "padding": "5.25px 7px"
          },
          "lg": {
            "padding": "14px 17.5px"
          }
        }
      },
      "footer": {
        "background": "#FFFFFF",
        "color": "#334155",
        "lg": {
          "padding": "14px 17.5px"
        },
        "sm": {
          "padding": "5.25px 7px"
        },
        "padding": "10.5px 14px",
        "cell": {
          "background": "#FFFFFF",
          "color": "#334155",
          "border": {
            "color": "#E2E8F0"
          },
          "padding": "10.5px 14px",
          "sm": {
            "padding": "5.25px 7px"
          },
          "lg": {
            "padding": "14px 17.5px"
          }
        },
        "border": {
          "color": "#E2E8F0",
          "width": "1px"
        }
      },
      "drop": {
        "point": {
          "color": "#2175A0"
        }
      },
      "column": {
        "title": {
          "font": {
            "weight": "600"
          }
        },
        "footer": {
          "font": {
            "weight": "600"
          }
        },
        "resizer": {
          "width": "7px"
        }
      },
      "resize": {
        "indicator": {
          "width": "1px",
          "color": "#2175A0"
        }
      },
      "sort": {
        "icon": {
          "color": "#64748B",
          "size": "12.25px",
          "hover": {
            "color": "#475569"
          }
        }
      },
      "loading": {
        "icon": {
          "size": "28px"
        }
      },
      "filter": {
        "inline": {
          "gap": "7px"
        },
        "overlay": {
          "select": {
            "background": "#FFFFFF",
            "color": "#334155",
            "border": {
              "color": "#E2E8F0",
              "radius": "6px"
            }
          },
          "popover": {
            "background": "#FFFFFF",
            "color": "#334155",
            "padding": "10.5px",
            "gap": "7px",
            "border": {
              "color": "#E2E8F0",
              "radius": "6px"
            }
          }
        },
        "rule": {
          "border": {
            "color": "#E2E8F0"
          }
        },
        "constraint": {
          "color": "#334155",
          "list": {
            "gap": "2px"
          },
          "focus": {
            "background": "#F1F5F9",
            "color": "#1E293B"
          },
          "selected": {
            "background": "#E8F8FB",
            "color": "#2175A0",
            "focus": {
              "background": "#CFEFF6",
              "color": "#195C7D"
            }
          },
          "separator": {
            "border": {
              "color": "#E2E8F0"
            }
          },
          "border": {
            "radius": "4px"
          }
        }
      },
      "paginator": {
        "top": {
          "border": {
            "color": "#E2E8F0",
            "width": "1px"
          }
        },
        "bottom": {
          "border": {
            "color": "#E2E8F0",
            "width": "1px"
          }
        }
      },
      "colorScheme": {
        "light": {
          "border": {
            "color": "#E2E8F0"
          },
          "row": {
            "striped": {
              "background": "#F8FAFC"
            }
          },
          "body": {
            "cell": {
              "selected": {
                "border": {
                  "color": "#CFEFF6"
                }
              }
            }
          }
        },
        "dark": {
          "border": {
            "color": "#1E293B"
          },
          "row": {
            "striped": {
              "background": "#020617"
            }
          },
          "body": {
            "cell": {
              "selected": {
                "border": {
                  "color": "#175270"
                }
              }
            }
          }
        }
      }
    },
    "dataview": {
      "padding": "0px",
      "border": {
        "color": "transparent",
        "width": "0px",
        "radius": "0px"
      },
      "header": {
        "background": "#FFFFFF",
        "color": "#334155",
        "padding": "10.5px 14px",
        "border": {
          "color": "#E2E8F0",
          "width": "1px",
          "radius": "0px"
        }
      },
      "content": {
        "background": "#FFFFFF",
        "color": "#334155",
        "padding": "0px",
        "border": {
          "color": "transparent",
          "radius": "0px",
          "width": "0px"
        }
      },
      "footer": {
        "background": "#FFFFFF",
        "color": "#334155",
        "padding": "10.5px 14px",
        "border": {
          "color": "#E2E8F0",
          "width": "1px",
          "radius": "0px"
        }
      },
      "paginator": {
        "top": {
          "border": {
            "color": "#E2E8F0",
            "width": "1px"
          }
        },
        "bottom": {
          "border": {
            "width": "1px",
            "color": "#E2E8F0"
          }
        }
      }
    },
    "dialog": {
      "background": "#FFFFFF",
      "color": "#334155",
      "border": {
        "color": "#E2E8F0",
        "radius": "12px"
      },
      "header": {
        "padding": "17.5px",
        "gap": "7px"
      },
      "title": {
        "font": {
          "size": "17.5px",
          "weight": "600"
        }
      },
      "footer": {
        "gap": "7px",
        "padding": "0px 17.5px 17.5px 17.5px"
      },
      "content": {
        "padding": "0px 17.5px 17.5px 17.5px"
      }
    },
    "divider": {
      "border": {
        "color": "#E2E8F0"
      },
      "content": {
        "background": "#FFFFFF",
        "color": "#334155"
      },
      "horizontal": {
        "padding": "0px",
        "margin": "14px 0px",
        "content": {
          "padding": "0px 7px"
        }
      },
      "vertical": {
        "padding": "0px",
        "margin": "0px 14px",
        "content": {
          "padding": "7px 0px"
        }
      }
    },
    "dock": {
      "background": "rgba(255, 255, 255, 0.1)",
      "padding": "7px",
      "border": {
        "color": "rgba(255, 255, 255, 0.2)",
        "radius": "12px"
      },
      "item": {
        "padding": "7px",
        "size": "42px",
        "border": {
          "radius": "6px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "2px",
            "color": "#0284C7"
          }
        }
      }
    },
    "drawer": {
      "background": "#FFFFFF",
      "color": "#334155",
      "content": {
        "padding": "0px 17.5px 17.5px 17.5px"
      },
      "border": {
        "color": "#E2E8F0",
        "radius": "12px"
      },
      "header": {
        "padding": "17.5px"
      },
      "footer": {
        "padding": "17.5px"
      },
      "title": {
        "font": {
          "weight": "600",
          "size": "21px"
        }
      }
    },
    "editor": {
      "toolbar": {
        "background": "#FFFFFF",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        },
        "item": {
          "color": "#64748B",
          "hover": {
            "color": "#334155"
          },
          "active": {
            "color": "#2175A0"
          }
        }
      },
      "overlay": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        },
        "option": {
          "color": "#334155",
          "focus": {
            "background": "#F1F5F9",
            "color": "#1E293B"
          },
          "border": {
            "radius": "4px"
          }
        }
      },
      "content": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        }
      }
    },
    "fieldset": {
      "background": "#FFFFFF",
      "color": "#334155",
      "padding": "15.75px 15.75px 15.75px 15.75px",
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "legend": {
        "background": "#FFFFFF",
        "color": "#334155",
        "gap": "7px",
        "padding": "7px 10.5px",
        "hover": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "border": {
          "radius": "6px",
          "width": "1px",
          "color": "transparent"
        },
        "font": {
          "weight": "600"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "color": "#0284C7",
            "offset": "2px"
          }
        }
      },
      "toggle": {
        "icon": {
          "color": "#64748B",
          "hover": {
            "color": "#475569"
          }
        }
      },
      "content": {
        "padding": "0px"
      }
    },
    "fileupload": {
      "background": "#FFFFFF",
      "color": "#334155",
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "header": {
        "background": "transparent",
        "color": "#334155",
        "padding": "15.75px",
        "gap": "7px",
        "border": {
          "width": "0px",
          "radius": "0px",
          "color": "transparent"
        }
      },
      "file": {
        "padding": "14px",
        "gap": "14px",
        "border": {
          "color": "#E2E8F0"
        },
        "info": {
          "gap": "7px"
        },
        "list": {
          "gap": "7px"
        }
      },
      "progressbar": {
        "height": "3.5px"
      },
      "basic": {
        "gap": "7px"
      },
      "content": {
        "gap": "14px",
        "padding": "0px 15.75px 15.75px 15.75px",
        "highlight": {
          "border": {
            "color": "#2175A0"
          }
        }
      }
    },
    "floatlabel": {
      "color": "#64748B",
      "focus": {
        "color": "#64748B"
      },
      "active": {
        "color": "#64748B",
        "font": {
          "weight": "400",
          "size": "10.5px"
        }
      },
      "position": {
        "x": "10.5px",
        "y": "7px"
      },
      "font": {
        "weight": "500"
      },
      "over": {
        "active": {
          "top": "-17.5px"
        }
      },
      "on": {
        "border": {
          "radius": "2px"
        },
        "active": {
          "background": "#FFFFFF",
          "padding": "0px 1.75px"
        }
      },
      "in": {
        "input": {
          "padding": {
            "top": "21px",
            "bottom": "7px"
          }
        },
        "active": {
          "top": "7px"
        }
      },
      "invalid": {
        "color": "#DC2626"
      }
    },
    "galleria": {
      "thumbnail": {
        "nav": {
          "button": {
            "size": "28px",
            "gutter": "7px",
            "border": {
              "radius": "6px"
            },
            "focus": {
              "ring": {
                "width": "1px",
                "color": "#0284C7",
                "offset": "2px"
              }
            },
            "icon": {
              "size": "14px"
            }
          }
        }
      },
      "indicator": {
        "button": {
          "width": "14px",
          "height": "14px",
          "active": {
            "background": "#2175A0"
          },
          "border": {
            "radius": "7px"
          },
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "2px",
              "color": "#0284C7"
            }
          }
        },
        "list": {
          "gap": "7px",
          "padding": "14px"
        }
      },
      "border": {
        "width": "1px",
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "nav": {
        "button": {
          "background": "rgba(255, 255, 255, 0.1)",
          "color": "#F1F5F9",
          "size": "42px",
          "gutter": "7px",
          "hover": {
            "background": "rgba(255, 255, 255, 0.2)",
            "color": "#FFFFFF"
          },
          "prev": {
            "border": {
              "radius": "21px"
            }
          },
          "next": {
            "border": {
              "radius": "21px"
            }
          },
          "focus": {
            "ring": {
              "width": "1px",
              "color": "#0284C7",
              "offset": "2px"
            }
          }
        },
        "icon": {
          "size": "21px"
        }
      },
      "thumbnails": {
        "content": {
          "background": "#FFFFFF",
          "padding": "14px 3.5px"
        }
      },
      "caption": {
        "background": "rgba(0, 0, 0, 0.5)",
        "color": "#F1F5F9",
        "padding": "14px"
      },
      "inset": {
        "indicator": {
          "list": {
            "background": "rgba(0, 0, 0, 0.5)"
          },
          "button": {
            "background": "rgba(255, 255, 255, 0.4)",
            "hover": {
              "background": "rgba(255, 255, 255, 0.6)"
            },
            "active": {
              "background": "rgba(255, 255, 255, 0.9)"
            }
          }
        }
      },
      "close": {
        "button": {
          "size": "42px",
          "gutter": "7px",
          "background": "rgba(255, 255, 255, 0.1)",
          "color": "#F8FAFC",
          "hover": {
            "background": "rgba(255, 255, 255, 0.2)",
            "color": "#FFFFFF"
          },
          "border": {
            "radius": "21px"
          },
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "2px",
              "color": "#0284C7"
            }
          },
          "icon": {
            "size": "21px"
          }
        }
      },
      "colorScheme": {
        "light": {
          "thumbnail": {
            "nav": {
              "button": {
                "color": "#475569",
                "hover": {
                  "background": "#F1F5F9",
                  "color": "#334155"
                }
              }
            }
          },
          "indicator": {
            "button": {
              "background": "#E2E8F0",
              "hover": {
                "background": "#CBD5E1"
              }
            }
          }
        },
        "dark": {
          "thumbnail": {
            "nav": {
              "button": {
                "color": "#94A3B8",
                "hover": {
                  "background": "#334155",
                  "color": "#FFFFFF"
                }
              }
            }
          },
          "indicator": {
            "button": {
              "background": "#334155",
              "hover": {
                "background": "#475569"
              }
            }
          }
        }
      }
    },
    "iconfield": {
      "icon": {
        "color": "#94A3B8"
      },
      "figma": {
        "sm": {
          "icon": {
            "size": "{inputtext.sm.font.size}"
          }
        },
        "lg": {
          "icon": {
            "size": "{inputtext.lg.font.size}"
          }
        }
      }
    },
    "iftalabel": {
      "top": "7px",
      "color": "#64748B",
      "input": {
        "padding": {
          "top": "21px",
          "bottom": "7px"
        }
      },
      "invalid": {
        "color": "#DC2626"
      },
      "font": {
        "weight": "400",
        "size": "10.5px"
      },
      "focus": {
        "color": "#64748B"
      },
      "position": {
        "x": "10.5px"
      }
    },
    "image": {
      "preview": {
        "icon": {
          "size": "21px"
        },
        "mask": {
          "background": "rgba(0, 0, 0, 0.1)",
          "color": "#E2E8F0"
        }
      },
      "toolbar": {
        "background": "rgba(255, 255, 255, 0.1)",
        "padding": "7px",
        "gap": "7px",
        "blur": "8px",
        "border": {
          "color": "rgba(255, 255, 255, 0.2)",
          "width": "1px",
          "radius": "30px"
        },
        "position": {
          "right": "14px",
          "top": "14px"
        }
      },
      "action": {
        "color": "#F8FAFC",
        "size": "42px",
        "hover": {
          "background": "rgba(255, 255, 255, 0.1)",
          "color": "#FFFFFF"
        },
        "icon": {
          "size": "21px"
        },
        "border": {
          "radius": "21px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "2px",
            "color": "#0284C7"
          }
        }
      }
    },
    "imagecompare": {
      "handle": {
        "size": "15px",
        "background": "rgba(255, 255, 255, 0.3)",
        "hover": {
          "size": "30px",
          "background": "rgba(255, 255, 255, 0.3)",
          "border": {
            "color": "transparent"
          }
        },
        "border": {
          "color": "transparent",
          "width": "0px",
          "radius": "7.5px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "2px",
            "color": "rgba(255, 255, 255, 0.3)"
          }
        }
      }
    },
    "inputgroup": {
      "addon": {
        "background": "#FFFFFF",
        "color": "#94A3B8",
        "padding": "7px",
        "border": {
          "color": "#CBD5E1",
          "radius": "6px"
        },
        "min": {
          "width": "35px"
        }
      }
    },
    "inputnumber": {
      "button": {
        "width": "35px",
        "border": {
          "radius": "6px"
        },
        "vertical": {
          "padding": "7px"
        }
      },
      "colorScheme": {
        "light": {
          "button": {
            "background": "transparent",
            "color": "#94A3B8",
            "hover": {
              "background": "#F1F5F9",
              "color": "#64748B",
              "border": {
                "color": "#CBD5E1"
              }
            },
            "active": {
              "background": "#E2E8F0",
              "color": "#475569",
              "border": {
                "color": "#CBD5E1"
              }
            },
            "border": {
              "color": "#CBD5E1"
            }
          }
        },
        "dark": {
          "button": {
            "background": "transparent",
            "color": "#94A3B8",
            "hover": {
              "background": "#1E293B",
              "color": "#CBD5E1",
              "border": {
                "color": "#CBD5E1"
              }
            },
            "active": {
              "background": "#334155",
              "color": "#E2E8F0",
              "border": {
                "color": "#CBD5E1"
              }
            },
            "border": {
              "color": "#CBD5E1"
            }
          }
        }
      }
    },
    "inputotp": {
      "gap": "7px",
      "input": {
        "width": "35px",
        "sm": {
          "width": "28px"
        },
        "lg": {
          "width": "42px"
        }
      }
    },
    "inputtext": {
      "background": "#FFFFFF",
      "color": "#334155",
      "disabled": {
        "background": "#E2E8F0",
        "color": "#475569"
      },
      "filled": {
        "background": "#F8FAFC",
        "focus": {
          "background": "#F8FAFC"
        },
        "hover": {
          "background": "#F8FAFC"
        }
      },
      "border": {
        "color": "#CBD5E1",
        "radius": "6px"
      },
      "hover": {
        "border": {
          "color": "#94A3B8"
        }
      },
      "focus": {
        "border": {
          "color": "#2175A0"
        },
        "ring": {
          "width": "0px",
          "color": "transparent",
          "offset": "0px"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        },
        "placeholder": {
          "color": "#DC2626"
        }
      },
      "placeholder": {
        "color": "#64748B"
      },
      "padding": {
        "x": "10.5px",
        "y": "7px"
      },
      "sm": {
        "font": {
          "size": "12.25px"
        },
        "padding": {
          "x": "8.75px",
          "y": "5.25px"
        }
      },
      "lg": {
        "padding": {
          "x": "12.25px",
          "y": "8.75px"
        },
        "font": {
          "size": "15.75px"
        }
      }
    },
    "inplace": {
      "border": {
        "radius": "6px"
      },
      "focus": {
        "ring": {
          "width": "1px",
          "offset": "2px",
          "color": "#0284C7"
        }
      },
      "display": {
        "hover": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        }
      },
      "padding": "7px 10.5px"
    },
    "knob": {
      "focus": {
        "ring": {
          "width": "1px",
          "offset": "2px",
          "color": "#0284C7"
        }
      },
      "value": {
        "background": "#2175A0"
      },
      "range": {
        "background": "#E2E8F0"
      },
      "text": {
        "color": "#64748B"
      }
    },
    "listbox": {
      "background": "#FFFFFF",
      "color": "#334155",
      "list": {
        "gap": "2px",
        "padding": "3.5px 3.5px",
        "header": {
          "padding": "7px 14px 3.5px 14px"
        }
      },
      "disabled": {
        "background": "#E2E8F0",
        "color": "#475569"
      },
      "border": {
        "color": "#CBD5E1",
        "radius": "6px"
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        }
      },
      "option": {
        "color": "#334155",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#E8F8FB",
          "color": "#2175A0",
          "focus": {
            "background": "#CFEFF6",
            "color": "#195C7D"
          }
        },
        "border": {
          "radius": "4px"
        },
        "group": {
          "background": "transparent",
          "color": "#64748B",
          "font": {
            "weight": "600"
          },
          "padding": "7px 10.5px"
        },
        "padding": "7px 10.5px"
      },
      "checkmark": {
        "color": "#334155",
        "gutter": {
          "start": "-5.25px",
          "end": "5.25px"
        }
      },
      "colorScheme": {
        "light": {
          "option": {
            "striped": {
              "background": "#F8FAFC"
            }
          }
        },
        "dark": {
          "option": {
            "striped": {
              "background": "#0F172A"
            }
          }
        }
      }
    },
    "megamenu": {
      "background": "#FFFFFF",
      "color": "#334155",
      "gap": "7px",
      "base": {
        "item": {
          "padding": "7px 10.5px",
          "border": {
            "radius": "6px"
          }
        }
      },
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "vertical": {
        "orientation": {
          "gap": "2px",
          "padding": "3.5px 3.5px"
        }
      },
      "item": {
        "color": "#334155",
        "gap": "7px",
        "padding": "7px 10.5px",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "active": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "border": {
          "radius": "4px"
        },
        "icon": {
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          },
          "active": {
            "color": "#64748B"
          }
        }
      },
      "overlay": {
        "padding": "0px",
        "background": "#FFFFFF",
        "color": "#334155",
        "gap": "7px",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        }
      },
      "separator": {
        "border": {
          "color": "#E2E8F0"
        }
      },
      "mobile": {
        "button": {
          "size": "24.5px",
          "color": "#64748B",
          "border": {
            "radius": "12.25px"
          },
          "hover": {
            "color": "#475569",
            "background": "#F1F5F9"
          },
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "2px",
              "color": "#0284C7"
            }
          }
        }
      },
      "submenu": {
        "gap": "2px",
        "padding": "3.5px 3.5px",
        "label": {
          "background": "transparent",
          "color": "#64748B",
          "padding": "7px 10.5px",
          "font": {
            "weight": "600"
          }
        },
        "icon": {
          "size": "12.25px",
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          },
          "active": {
            "color": "#64748B"
          }
        }
      },
      "horizontal": {
        "orientation": {
          "gap": "7px",
          "padding": "7px 10.5px"
        }
      }
    },
    "menu": {
      "background": "#FFFFFF",
      "color": "#334155",
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "list": {
        "gap": "2px",
        "padding": "3.5px 3.5px"
      },
      "item": {
        "color": "#334155",
        "gap": "7px",
        "padding": "7px 10.5px",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "border": {
          "radius": "4px"
        },
        "icon": {
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          }
        }
      },
      "submenu": {
        "label": {
          "background": "transparent",
          "color": "#64748B",
          "font": {
            "weight": "600"
          },
          "padding": "7px 10.5px"
        }
      },
      "separator": {
        "border": {
          "color": "#E2E8F0"
        }
      }
    },
    "menubar": {
      "background": "#FFFFFF",
      "color": "#334155",
      "gap": "7px",
      "base": {
        "item": {
          "padding": "7px 10.5px",
          "border": {
            "radius": "6px"
          }
        }
      },
      "padding": "7px 10.5px",
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "item": {
        "color": "#334155",
        "gap": "7px",
        "padding": "7px 10.5px",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "active": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "border": {
          "radius": "4px"
        },
        "icon": {
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          },
          "active": {
            "color": "#64748B"
          }
        }
      },
      "submenu": {
        "gap": "2px",
        "background": "#FFFFFF",
        "padding": "3.5px 3.5px",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        },
        "mobile": {
          "indent": "14px"
        },
        "icon": {
          "size": "12.25px",
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          },
          "active": {
            "color": "#64748B"
          }
        }
      },
      "separator": {
        "border": {
          "color": "#E2E8F0"
        }
      },
      "mobile": {
        "button": {
          "size": "24.5px",
          "color": "#64748B",
          "border": {
            "radius": "12.25px"
          },
          "hover": {
            "color": "#475569",
            "background": "#F1F5F9"
          },
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "2px",
              "color": "#0284C7"
            }
          }
        }
      }
    },
    "message": {
      "border": {
        "radius": "6px",
        "width": "1px"
      },
      "content": {
        "gap": "7px",
        "lg": {
          "padding": "8.75px 12.25px"
        },
        "sm": {
          "padding": "5.25px 8.75px"
        },
        "padding": "7px 10.5px"
      },
      "text": {
        "font": {
          "size": "14px",
          "weight": "500"
        },
        "sm": {
          "font": {
            "size": "12.25px"
          }
        },
        "lg": {
          "font": {
            "size": "15.75px"
          }
        }
      },
      "icon": {
        "size": "15.75px",
        "sm": {
          "size": "14px"
        },
        "lg": {
          "size": "17.5px"
        }
      },
      "close": {
        "button": {
          "width": "24.5px",
          "height": "24.5px",
          "border": {
            "radius": "12.25px"
          },
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "2px"
            }
          }
        },
        "icon": {
          "size": "14px",
          "sm": {
            "size": "12.25px"
          },
          "lg": {
            "size": "15.75px"
          }
        }
      },
      "outlined": {
        "border": {
          "width": "1px"
        }
      },
      "simple": {
        "content": {
          "padding": "0px"
        }
      },
      "colorScheme": {
        "light": {
          "info": {
            "background": "rgba(239, 246, 255, 0.95)",
            "color": "#2563EB",
            "border": {
              "color": "#BFDBFE"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#DBEAFE"
                },
                "focus": {
                  "ring": {
                    "color": "#2563EB"
                  }
                }
              }
            },
            "outlined": {
              "color": "#2563EB",
              "border": {
                "color": "#2563EB"
              }
            },
            "simple": {
              "color": "#2563EB"
            }
          },
          "success": {
            "background": "rgba(240, 253, 244, 0.95)",
            "color": "#16A34A",
            "border": {
              "color": "#BBF7D0"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#DCFCE7"
                },
                "focus": {
                  "ring": {
                    "color": "#16A34A"
                  }
                }
              }
            },
            "outlined": {
              "color": "#16A34A",
              "border": {
                "color": "#16A34A"
              }
            },
            "simple": {
              "color": "#16A34A"
            }
          },
          "warn": {
            "background": "rgba(254, 252, 232, 0.95)",
            "color": "#CA8A04",
            "border": {
              "color": "#FEF08A"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#FEF9C3"
                },
                "focus": {
                  "ring": {
                    "color": "#CA8A04"
                  }
                }
              }
            },
            "outlined": {
              "color": "#CA8A04",
              "border": {
                "color": "#CA8A04"
              }
            },
            "simple": {
              "color": "#CA8A04"
            }
          },
          "error": {
            "background": "rgba(254, 242, 242, 0.95)",
            "color": "#DC2626",
            "border": {
              "color": "#FECACA"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#FEE2E2"
                },
                "focus": {
                  "ring": {
                    "color": "#DC2626"
                  }
                }
              }
            },
            "outlined": {
              "color": "#DC2626",
              "border": {
                "color": "#DC2626"
              }
            },
            "simple": {
              "color": "#DC2626"
            }
          },
          "secondary": {
            "background": "#F1F5F9",
            "color": "#475569",
            "border": {
              "color": "#E2E8F0"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#E2E8F0"
                },
                "focus": {
                  "ring": {
                    "color": "#475569"
                  }
                }
              }
            },
            "outlined": {
              "color": "#64748B",
              "border": {
                "color": "#64748B"
              }
            },
            "simple": {
              "color": "#64748B"
            }
          },
          "contrast": {
            "background": "#0F172A",
            "color": "#F8FAFC",
            "border": {
              "color": "#020617"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#1E293B"
                },
                "focus": {
                  "ring": {
                    "color": "#F8FAFC"
                  }
                }
              }
            },
            "outlined": {
              "color": "#020617",
              "border": {
                "color": "#020617"
              }
            },
            "simple": {
              "color": "#020617"
            }
          }
        },
        "dark": {
          "info": {
            "background": "rgba(59, 130, 246, 0.16)",
            "color": "#3B82F6",
            "border": {
              "color": "rgba(29, 78, 216, 0.36)"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "rgba(255, 255, 255, 0.05)"
                },
                "focus": {
                  "ring": {
                    "color": "#3B82F6"
                  }
                }
              }
            },
            "outlined": {
              "color": "#3B82F6",
              "border": {
                "color": "#3B82F6"
              }
            },
            "simple": {
              "color": "#3B82F6"
            }
          },
          "success": {
            "background": "rgba(34, 197, 94, 0.16)",
            "color": "#22C55E",
            "border": {
              "color": "rgba(21, 128, 61, 0.36)"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "rgba(255, 255, 255, 0.05)"
                },
                "focus": {
                  "ring": {
                    "color": "#22C55E"
                  }
                }
              }
            },
            "outlined": {
              "color": "#22C55E",
              "border": {
                "color": "#22C55E"
              }
            },
            "simple": {
              "color": "#22C55E"
            }
          },
          "warn": {
            "background": "rgba(234, 179, 8, 0.16)",
            "color": "#EAB308",
            "border": {
              "color": "rgba(161, 98, 7, 0.36)"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "rgba(255, 255, 255, 0.05)"
                },
                "focus": {
                  "ring": {
                    "color": "#EAB308"
                  }
                }
              }
            },
            "outlined": {
              "color": "#EAB308",
              "border": {
                "color": "#EAB308"
              }
            },
            "simple": {
              "color": "#EAB308"
            }
          },
          "error": {
            "background": "rgba(239, 68, 68, 0.16)",
            "color": "#EF4444",
            "border": {
              "color": "rgba(185, 28, 28, 0.36)"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "rgba(255, 255, 255, 0.05)"
                },
                "focus": {
                  "ring": {
                    "color": "#EF4444"
                  }
                }
              }
            },
            "outlined": {
              "color": "#EF4444",
              "border": {
                "color": "#EF4444"
              }
            },
            "simple": {
              "color": "#EF4444"
            }
          },
          "secondary": {
            "background": "#1E293B",
            "color": "#CBD5E1",
            "border": {
              "color": "#334155"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#334155"
                },
                "focus": {
                  "ring": {
                    "color": "#CBD5E1"
                  }
                }
              }
            },
            "outlined": {
              "color": "#94A3B8",
              "border": {
                "color": "#94A3B8"
              }
            },
            "simple": {
              "color": "#94A3B8"
            }
          },
          "contrast": {
            "background": "#FFFFFF",
            "color": "#020617",
            "border": {
              "color": "#F1F5F9"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#F1F5F9"
                },
                "focus": {
                  "ring": {
                    "color": "#020617"
                  }
                }
              }
            },
            "outlined": {
              "color": "#FFFFFF",
              "border": {
                "color": "#FFFFFF"
              }
            },
            "simple": {
              "color": "#FFFFFF"
            }
          }
        }
      }
    },
    "metergroup": {
      "gap": "14px",
      "meters": {
        "background": "#E2E8F0",
        "size": "7px"
      },
      "label": {
        "gap": "7px",
        "marker": {
          "size": "7px"
        },
        "icon": {
          "size": "14px"
        },
        "list": {
          "vertical": {
            "gap": "7px"
          },
          "horizontal": {
            "gap": "14px"
          }
        }
      },
      "border": {
        "radius": "6px"
      }
    },
    "multiselect": {
      "background": "#FFFFFF",
      "color": "#334155",
      "option": {
        "color": "#334155",
        "gap": "7px",
        "padding": "7px 10.5px",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#E8F8FB",
          "color": "#2175A0",
          "focus": {
            "background": "#CFEFF6",
            "color": "#195C7D"
          }
        },
        "border": {
          "radius": "4px"
        },
        "group": {
          "background": "transparent",
          "color": "#64748B",
          "padding": "7px 10.5px",
          "font": {
            "weight": "600"
          }
        }
      },
      "disabled": {
        "background": "#E2E8F0",
        "color": "#475569"
      },
      "filled": {
        "background": "#F8FAFC",
        "focus": {
          "background": "#F8FAFC"
        },
        "hover": {
          "background": "#F8FAFC"
        }
      },
      "border": {
        "color": "#CBD5E1",
        "radius": "6px"
      },
      "hover": {
        "border": {
          "color": "#94A3B8"
        }
      },
      "focus": {
        "border": {
          "color": "#2175A0"
        },
        "ring": {
          "width": "0px",
          "offset": "0px",
          "color": "transparent"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        },
        "placeholder": {
          "color": "#DC2626"
        }
      },
      "placeholder": {
        "color": "#64748B"
      },
      "padding": {
        "x": "10.5px",
        "y": "7px"
      },
      "dropdown": {
        "width": "35px",
        "color": "#94A3B8"
      },
      "overlay": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        }
      },
      "list": {
        "gap": "2px",
        "padding": "3.5px 3.5px",
        "header": {
          "padding": "7px 14px 3.5px 14px"
        }
      },
      "chip": {
        "border": {
          "radius": "4px"
        }
      },
      "sm": {
        "padding": {
          "x": "8.75px",
          "y": "5.25px"
        },
        "font": {
          "size": "12.25px"
        }
      },
      "lg": {
        "padding": {
          "x": "12.25px",
          "y": "8.75px"
        },
        "font": {
          "size": "15.75px"
        }
      },
      "clear": {
        "icon": {
          "color": "#94A3B8"
        }
      }
    },
    "orderlist": {
      "gap": "15.75px",
      "controls": {
        "gap": "7px"
      }
    },
    "organizationchart": {
      "gutter": "10.5px",
      "node": {
        "background": "#FFFFFF",
        "color": "#334155",
        "toggleable": {
          "padding": "10.5px 14px 17.5px 14px"
        },
        "padding": "10.5px 14px",
        "hover": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#E8F8FB",
          "color": "#2175A0"
        },
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        },
        "toggle": {
          "button": {
            "background": "#FFFFFF",
            "color": "#64748B",
            "size": "21px",
            "hover": {
              "background": "#F1F5F9",
              "color": "#334155"
            },
            "border": {
              "color": "#E2E8F0",
              "radius": "10.5px"
            },
            "focus": {
              "ring": {
                "width": "1px",
                "offset": "2px",
                "color": "#0284C7"
              }
            }
          }
        }
      },
      "connector": {
        "color": "#E2E8F0",
        "height": "24px",
        "border": {
          "radius": "6px"
        }
      }
    },
    "overlaybadge": {
      "outline": {
        "color": "#FFFFFF",
        "width": "2px"
      }
    },
    "paginator": {
      "gap": "3.5px",
      "background": "#FFFFFF",
      "color": "#334155",
      "padding": "7px 14px",
      "border": {
        "radius": "6px"
      },
      "nav": {
        "button": {
          "background": "transparent",
          "width": "35px",
          "height": "35px",
          "color": "#64748B",
          "hover": {
            "background": "#F1F5F9",
            "color": "#475569"
          },
          "selected": {
            "background": "#E8F8FB",
            "color": "#2175A0"
          },
          "border": {
            "radius": "17.5px"
          },
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "2px",
              "color": "#0284C7"
            }
          }
        }
      },
      "current": {
        "page": {
          "report": {
            "color": "#64748B"
          }
        }
      },
      "jump": {
        "to": {
          "page": {
            "input": {
              "max": {
                "width": "35px"
              }
            }
          }
        }
      }
    },
    "panel": {
      "background": "#FFFFFF",
      "color": "#334155",
      "toggleable": {
        "header": {
          "padding": "5.25px 15.75px"
        }
      },
      "footer": {
        "padding": "0px 15.75px 15.75px 15.75px"
      },
      "content": {
        "padding": "0px 15.75px 15.75px 15.75px"
      },
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "header": {
        "background": "transparent",
        "color": "#334155",
        "padding": "15.75px",
        "border": {
          "color": "#E2E8F0",
          "radius": "0px",
          "width": "0px 0px 0px 0px"
        }
      },
      "title": {
        "font": {
          "weight": "600"
        }
      }
    },
    "panelmenu": {
      "gap": "7px",
      "panel": {
        "background": "#FFFFFF",
        "color": "#334155",
        "padding": "3.5px 3.5px",
        "border": {
          "color": "#E2E8F0",
          "width": "1px",
          "radius": "6px"
        },
        "first": {
          "border": {
            "width": "1px"
          },
          "top": {
            "border": {
              "radius": "6px"
            }
          }
        },
        "last": {
          "border": {
            "width": "1px"
          },
          "bottom": {
            "border": {
              "radius": "6px"
            }
          }
        }
      },
      "item": {
        "color": "#334155",
        "gap": "7px",
        "padding": "7px 10.5px",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "border": {
          "radius": "6px"
        },
        "icon": {
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          }
        }
      },
      "submenu": {
        "indent": "14px",
        "icon": {
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          }
        }
      }
    },
    "password": {
      "meter": {
        "background": "#E2E8F0",
        "height": "10.5px",
        "border": {
          "radius": "6px"
        }
      },
      "icon": {
        "color": "#94A3B8"
      },
      "overlay": {
        "background": "#FFFFFF",
        "color": "#334155",
        "padding": "10.5px",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        }
      },
      "content": {
        "gap": "7px"
      },
      "colorScheme": {
        "light": {
          "strength": {
            "weak": {
              "background": "#EF4444"
            },
            "medium": {
              "background": "#F59E0B"
            },
            "strong": {
              "background": "#22C55E"
            }
          }
        },
        "dark": {
          "strength": {
            "weak": {
              "background": "#F87171"
            },
            "medium": {
              "background": "#FBBF24"
            },
            "strong": {
              "background": "#4ADE80"
            }
          }
        }
      }
    },
    "picklist": {
      "gap": "15.75px",
      "controls": {
        "gap": "7px"
      }
    },
    "popover": {
      "background": "#FFFFFF",
      "color": "#334155",
      "gutter": "10px",
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "arrow": {
        "offset": "17.5px"
      },
      "content": {
        "padding": "10.5px"
      }
    },
    "progressbar": {
      "background": "#E2E8F0",
      "height": "17.5px",
      "border": {
        "radius": "6px"
      },
      "value": {
        "background": "#2175A0"
      },
      "label": {
        "color": "#FFFFFF",
        "font": {
          "size": "10.5px",
          "weight": "600"
        }
      }
    },
    "radiobutton": {
      "width": "17.5px",
      "height": "17.5px",
      "background": "#FFFFFF",
      "checked": {
        "background": "#2175A0",
        "hover": {
          "background": "#2175A0",
          "border": {
            "color": "#2175A0"
          }
        },
        "border": {
          "color": "#2175A0"
        },
        "focus": {
          "border": {
            "color": "#2175A0"
          }
        },
        "disabled": {
          "border": {
            "color": "#CBD5E1"
          }
        }
      },
      "disabled": {
        "background": "#E2E8F0"
      },
      "filled": {
        "background": "#F8FAFC"
      },
      "border": {
        "color": "#CBD5E1"
      },
      "hover": {
        "border": {
          "color": "#94A3B8"
        }
      },
      "focus": {
        "border": {
          "color": "#CBD5E1"
        },
        "ring": {
          "width": "1px",
          "color": "#0284C7",
          "offset": "2px"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        }
      },
      "icon": {
        "size": "10.5px",
        "checked": {
          "color": "#FFFFFF",
          "hover": {
            "color": "#FFFFFF"
          }
        },
        "disabled": {
          "color": "#475569"
        },
        "sm": {
          "size": "7px"
        },
        "lg": {
          "size": "14px"
        }
      },
      "sm": {
        "width": "14px",
        "height": "14px"
      },
      "lg": {
        "width": "21px",
        "height": "21px"
      }
    },
    "rating": {
      "gap": "3.5px",
      "icon": {
        "size": "14px",
        "color": "#64748B",
        "hover": {
          "color": "#2175A0"
        },
        "active": {
          "color": "#2175A0"
        }
      },
      "focus": {
        "ring": {
          "width": "1px",
          "color": "#0284C7",
          "offset": "2px"
        }
      }
    },
    "scrollpanel": {
      "bar": {
        "size": "9px",
        "border": {
          "radius": "4px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "2px",
            "color": "#0284C7"
          }
        }
      },
      "colorScheme": {
        "light": {
          "bar": {
            "background": "#F1F5F9"
          }
        },
        "dark": {
          "bar": {
            "background": "#1E293B"
          }
        }
      }
    },
    "select": {
      "background": "#FFFFFF",
      "color": "#334155",
      "disabled": {
        "background": "#E2E8F0",
        "color": "#475569"
      },
      "filled": {
        "background": "#F8FAFC",
        "focus": {
          "background": "#F8FAFC"
        },
        "hover": {
          "background": "#F8FAFC"
        }
      },
      "border": {
        "color": "#CBD5E1",
        "radius": "6px"
      },
      "hover": {
        "border": {
          "color": "#94A3B8"
        }
      },
      "focus": {
        "border": {
          "color": "#2175A0"
        },
        "ring": {
          "width": "0px",
          "offset": "0px",
          "color": "transparent"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        },
        "placeholder": {
          "color": "#DC2626"
        }
      },
      "placeholder": {
        "color": "#64748B"
      },
      "padding": {
        "x": "10.5px",
        "y": "7px"
      },
      "dropdown": {
        "width": "35px",
        "color": "#94A3B8"
      },
      "overlay": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        }
      },
      "list": {
        "gap": "2px",
        "padding": "3.5px 3.5px",
        "header": {
          "padding": "7px 14px 3.5px 14px"
        }
      },
      "option": {
        "color": "#334155",
        "group": {
          "background": "transparent",
          "color": "#64748B",
          "padding": "7px 10.5px",
          "font": {
            "weight": "600"
          }
        },
        "padding": "7px 10.5px",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#E8F8FB",
          "color": "#2175A0",
          "focus": {
            "background": "#CFEFF6",
            "color": "#195C7D"
          }
        },
        "border": {
          "radius": "4px"
        }
      },
      "clear": {
        "icon": {
          "color": "#94A3B8"
        }
      },
      "checkmark": {
        "color": "#334155",
        "gutter": {
          "start": "-5.25px",
          "end": "5.25px"
        }
      },
      "sm": {
        "font": {
          "size": "12.25px"
        },
        "padding": {
          "x": "8.75px",
          "y": "5.25px"
        }
      },
      "lg": {
        "font": {
          "size": "15.75px"
        },
        "padding": {
          "x": "12.25px",
          "y": "8.75px"
        }
      }
    },
    "selectbutton": {
      "border": {
        "radius": "6px"
      },
      "colorScheme": {
        "light": {
          "invalid": {
            "border": {
              "color": "#F87171"
            }
          }
        },
        "dark": {
          "invalid": {
            "border": {
              "color": "#F87171"
            }
          }
        }
      }
    },
    "skeleton": {
      "border": {
        "radius": "6px"
      },
      "colorScheme": {
        "light": {
          "background": "#E2E8F0"
        },
        "dark": {
          "background": "rgba(255, 255, 255, 0.06)"
        }
      }
    },
    "slider": {
      "track": {
        "background": "#E2E8F0",
        "size": "3px",
        "border": {
          "radius": "6px"
        }
      },
      "range": {
        "background": "#2175A0"
      },
      "handle": {
        "width": "20px",
        "height": "20px",
        "background": "#E2E8F0",
        "content": {
          "width": "16px",
          "height": "16px",
          "hover": {
            "background": "#FFFFFF"
          },
          "border": {
            "radius": "8px"
          }
        },
        "border": {
          "radius": "10px"
        },
        "hover": {
          "background": "#E2E8F0"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "2px",
            "color": "#0284C7"
          }
        }
      },
      "colorScheme": {
        "light": {
          "handle": {
            "content": {
              "background": "#FFFFFF"
            }
          }
        },
        "dark": {
          "handle": {
            "content": {
              "background": "#020617"
            }
          }
        }
      }
    },
    "speeddial": {
      "gap": "7px"
    },
    "splitbutton": {
      "border": {
        "radius": "6px"
      },
      "rounded": {
        "border": {
          "radius": "28px"
        }
      }
    },
    "splitter": {
      "background": "#FFFFFF",
      "color": "#334155",
      "border": {
        "color": "#E2E8F0"
      },
      "gutter": {
        "background": "#E2E8F0"
      },
      "handle": {
        "size": "24px",
        "background": "transparent",
        "border": {
          "radius": "6px"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "color": "#0284C7",
            "offset": "2px"
          }
        }
      }
    },
    "stepper": {
      "separator": {
        "background": "#E2E8F0",
        "size": "2px",
        "margin": "0px 0px 0px 22.75px",
        "active": {
          "background": "#2175A0"
        }
      },
      "step": {
        "padding": "7px",
        "gap": "14px",
        "header": {
          "padding": "0px",
          "gap": "7px",
          "border": {
            "radius": "6px"
          },
          "focus": {
            "ring": {
              "width": "1px",
              "color": "#0284C7",
              "offset": "2px"
            }
          }
        },
        "title": {
          "color": "#64748B",
          "active": {
            "color": "#2175A0"
          },
          "font": {
            "weight": "500"
          }
        },
        "number": {
          "background": "#FFFFFF",
          "color": "#64748B",
          "size": "28px",
          "active": {
            "background": "#FFFFFF",
            "color": "#2175A0",
            "border": {
              "color": "#E2E8F0"
            }
          },
          "border": {
            "color": "#E2E8F0",
            "radius": "14px"
          },
          "font": {
            "size": "16px",
            "weight": "500"
          }
        }
      },
      "steppanel": {
        "background": "#FFFFFF",
        "color": "#334155",
        "padding": "0px"
      },
      "steppanels": {
        "padding": "12.25px 7px 15.75px 7px"
      }
    },
    "tabs": {
      "tablist": {
        "background": "#FFFFFF",
        "border": {
          "color": "#E2E8F0",
          "width": "1px"
        }
      },
      "tab": {
        "color": "#64748B",
        "background": "transparent",
        "gap": "7px",
        "padding": "14px 15.75px",
        "border": {
          "color": "#E2E8F0",
          "width": "1px"
        },
        "hover": {
          "color": "#334155",
          "background": "transparent",
          "border": {
            "color": "#E2E8F0"
          }
        },
        "active": {
          "color": "#2175A0",
          "background": "transparent",
          "border": {
            "color": "#2175A0"
          }
        },
        "font": {
          "weight": "600"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "-1px",
            "color": "#0284C7"
          }
        }
      },
      "tabpanel": {
        "background": "#FFFFFF",
        "color": "#334155",
        "padding": "12.25px 15.75px 15.75px 15.75px",
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "2px",
            "color": "#0284C7"
          }
        }
      },
      "nav": {
        "button": {
          "background": "#FFFFFF",
          "color": "#64748B",
          "width": "35px",
          "hover": {
            "color": "#334155"
          },
          "focus": {
            "ring": {
              "color": "#0284C7",
              "width": "1px",
              "offset": "-1px"
            }
          }
        }
      },
      "active": {
        "bar": {
          "height": "1px",
          "bottom": "-1px",
          "background": "#2175A0"
        }
      }
    },
    "tag": {
      "gap": "3.5px",
      "font": {
        "size": "12.25px",
        "weight": "700"
      },
      "border": {
        "radius": "6px"
      },
      "rounded": {
        "border": {
          "radius": "12px"
        }
      },
      "icon": {
        "size": "10.5px"
      },
      "padding": "3.5px 7px",
      "colorScheme": {
        "light": {
          "primary": {
            "background": "#CFEFF6",
            "color": "#195C7D"
          },
          "secondary": {
            "background": "#F1F5F9",
            "color": "#475569"
          },
          "success": {
            "background": "#DCFCE7",
            "color": "#15803D"
          },
          "info": {
            "background": "#E0F2FE",
            "color": "#0369A1"
          },
          "warn": {
            "background": "#FFEDD5",
            "color": "#C2410C"
          },
          "danger": {
            "background": "#FEE2E2",
            "color": "#B91C1C"
          },
          "contrast": {
            "background": "#020617",
            "color": "#FFFFFF"
          },
          "figma": {
            "container": {
              "background": "transparent"
            }
          }
        },
        "dark": {
          "primary": {
            "background": "rgba(16, 185, 129, 0.16)",
            "color": "#6CB7D7"
          },
          "secondary": {
            "background": "#1E293B",
            "color": "#CBD5E1"
          },
          "success": {
            "background": "rgba(34, 197, 94, 0.16)",
            "color": "#86EFAC"
          },
          "info": {
            "background": "rgba(14, 165, 233, 0.16)",
            "color": "#7DD3FC"
          },
          "warn": {
            "background": "rgba(249, 115, 22, 0.16)",
            "color": "#FDBA74"
          },
          "danger": {
            "background": "rgba(239, 68, 68, 0.16)",
            "color": "#FCA5A5"
          },
          "contrast": {
            "background": "#FFFFFF",
            "color": "#020617"
          },
          "figma": {
            "container": {
              "background": "rgba(0, 0, 0, 0.7)"
            }
          }
        }
      }
    },
    "terminal": {
      "background": "#FFFFFF",
      "color": "#334155",
      "height": "252px",
      "border": {
        "color": "#CBD5E1",
        "radius": "6px"
      },
      "prompt": {
        "gap": "3.5px"
      },
      "command": {
        "response": {
          "margin": "2px 0px"
        }
      },
      "padding": "7px 10.5px"
    },
    "textarea": {
      "background": "#FFFFFF",
      "color": "#334155",
      "disabled": {
        "background": "#E2E8F0",
        "color": "#475569"
      },
      "filled": {
        "background": "#F8FAFC",
        "focus": {
          "background": "#F8FAFC"
        },
        "hover": {
          "background": "#F8FAFC"
        }
      },
      "border": {
        "color": "#CBD5E1",
        "radius": "6px"
      },
      "hover": {
        "border": {
          "color": "#94A3B8"
        }
      },
      "focus": {
        "border": {
          "color": "#2175A0"
        },
        "ring": {
          "width": "0px",
          "offset": "0px",
          "color": "transparent"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        },
        "placeholder": {
          "color": "#DC2626"
        }
      },
      "placeholder": {
        "color": "#64748B"
      },
      "padding": {
        "x": "10.5px",
        "y": "7px"
      },
      "sm": {
        "padding": {
          "x": "8.75px",
          "y": "5.25px"
        },
        "font": {
          "size": "12.25px"
        }
      },
      "lg": {
        "padding": {
          "x": "12.25px",
          "y": "8.75px"
        },
        "font": {
          "size": "15.75px"
        }
      }
    },
    "tieredmenu": {
      "background": "#FFFFFF",
      "color": "#334155",
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      },
      "list": {
        "gap": "2px",
        "padding": "3.5px 3.5px"
      },
      "item": {
        "color": "#334155",
        "gap": "7px",
        "padding": "7px 10.5px",
        "focus": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "active": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "border": {
          "radius": "4px"
        },
        "icon": {
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          },
          "active": {
            "color": "#64748B"
          }
        }
      },
      "submenu": {
        "icon": {
          "size": "12.25px",
          "color": "#94A3B8",
          "focus": {
            "color": "#64748B"
          },
          "active": {
            "color": "#64748B"
          }
        },
        "mobile": {
          "indent": "14px"
        }
      },
      "separator": {
        "border": {
          "color": "#E2E8F0"
        }
      }
    },
    "timeline": {
      "event": {
        "min": {
          "height": "70px"
        },
        "marker": {
          "size": "15.75px",
          "background": "#FFFFFF",
          "border": {
            "radius": "7.875px",
            "width": "2px",
            "color": "#E2E8F0"
          },
          "content": {
            "size": "5.25px",
            "background": "#2175A0",
            "border": {
              "radius": "2.625px"
            }
          }
        },
        "connector": {
          "color": "#E2E8F0",
          "size": "2px"
        }
      },
      "vertical": {
        "event": {
          "content": {
            "padding": "0px 14px"
          }
        }
      },
      "horizontal": {
        "event": {
          "content": {
            "padding": "14px 0px"
          }
        }
      }
    },
    "toast": {
      "width": "350px",
      "border": {
        "radius": "6px",
        "width": "1px"
      },
      "icon": {
        "size": "15.75px"
      },
      "content": {
        "padding": "10.5px",
        "gap": "7px"
      },
      "summary": {
        "font": {
          "weight": "500",
          "size": "14px"
        }
      },
      "detail": {
        "font": {
          "weight": "500",
          "size": "12.25px"
        }
      },
      "close": {
        "button": {
          "width": "24.5px",
          "height": "24.5px",
          "border": {
            "radius": "12.25px"
          },
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "2px"
            }
          }
        },
        "icon": {
          "size": "14px"
        }
      },
      "text": {
        "gap": "7px"
      },
      "colorScheme": {
        "light": {
          "blur": "1.5px",
          "info": {
            "background": "rgba(239, 246, 255, 0.95)",
            "color": "#2563EB",
            "border": {
              "color": "#BFDBFE"
            },
            "detail": {
              "color": "#334155"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#DBEAFE"
                },
                "focus": {
                  "ring": {
                    "color": "#2563EB"
                  }
                }
              }
            }
          },
          "success": {
            "background": "rgba(240, 253, 244, 0.95)",
            "color": "#16A34A",
            "border": {
              "color": "#BBF7D0"
            },
            "detail": {
              "color": "#334155"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#DCFCE7"
                },
                "focus": {
                  "ring": {
                    "color": "#16A34A"
                  }
                }
              }
            }
          },
          "warn": {
            "background": "rgba(254, 252, 232, 0.95)",
            "color": "#CA8A04",
            "border": {
              "color": "#FEF08A"
            },
            "detail": {
              "color": "#334155"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#FEF9C3"
                },
                "focus": {
                  "ring": {
                    "color": "#CA8A04"
                  }
                }
              }
            }
          },
          "error": {
            "background": "rgba(254, 242, 242, 0.95)",
            "color": "#DC2626",
            "border": {
              "color": "#FECACA"
            },
            "detail": {
              "color": "#334155"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#FEE2E2"
                },
                "focus": {
                  "ring": {
                    "color": "#DC2626"
                  }
                }
              }
            }
          },
          "secondary": {
            "background": "#F1F5F9",
            "color": "#475569",
            "border": {
              "color": "#E2E8F0"
            },
            "detail": {
              "color": "#334155"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#E2E8F0"
                },
                "focus": {
                  "ring": {
                    "color": "#475569"
                  }
                }
              }
            }
          },
          "contrast": {
            "background": "#0F172A",
            "color": "#F8FAFC",
            "border": {
              "color": "#020617"
            },
            "detail": {
              "color": "#FFFFFF"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#1E293B"
                },
                "focus": {
                  "ring": {
                    "color": "#F8FAFC"
                  }
                }
              }
            }
          }
        },
        "dark": {
          "blur": "10px",
          "info": {
            "background": "rgba(59, 130, 246, 0.16)",
            "color": "#3B82F6",
            "border": {
              "color": "rgba(29, 78, 216, 0.36)"
            },
            "detail": {
              "color": "#FFFFFF"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "rgba(255, 255, 255, 0.05)"
                },
                "focus": {
                  "ring": {
                    "color": "#3B82F6"
                  }
                }
              }
            }
          },
          "success": {
            "background": "rgba(34, 197, 94, 0.16)",
            "color": "#22C55E",
            "border": {
              "color": "rgba(21, 128, 61, 0.36)"
            },
            "detail": {
              "color": "#FFFFFF"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "rgba(255, 255, 255, 0.05)"
                },
                "focus": {
                  "ring": {
                    "color": "#22C55E"
                  }
                }
              }
            }
          },
          "warn": {
            "background": "rgba(234, 179, 8, 0.16)",
            "color": "#EAB308",
            "border": {
              "color": "rgba(161, 98, 7, 0.36)"
            },
            "detail": {
              "color": "#FFFFFF"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "rgba(255, 255, 255, 0.05)"
                },
                "focus": {
                  "ring": {
                    "color": "#EAB308"
                  }
                }
              }
            }
          },
          "error": {
            "background": "rgba(239, 68, 68, 0.16)",
            "color": "#EF4444",
            "border": {
              "color": "rgba(185, 28, 28, 0.36)"
            },
            "detail": {
              "color": "#FFFFFF"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "rgba(255, 255, 255, 0.05)"
                },
                "focus": {
                  "ring": {
                    "color": "#EF4444"
                  }
                }
              }
            }
          },
          "secondary": {
            "background": "#1E293B",
            "color": "#CBD5E1",
            "border": {
              "color": "#334155"
            },
            "detail": {
              "color": "#FFFFFF"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#334155"
                },
                "focus": {
                  "ring": {
                    "color": "#CBD5E1"
                  }
                }
              }
            }
          },
          "contrast": {
            "background": "#FFFFFF",
            "color": "#020617",
            "border": {
              "color": "#F1F5F9"
            },
            "detail": {
              "color": "#020617"
            },
            "close": {
              "button": {
                "hover": {
                  "background": "#F1F5F9"
                },
                "focus": {
                  "ring": {
                    "color": "#020617"
                  }
                }
              }
            }
          }
        }
      }
    },
    "togglebutton": {
      "gap": "7px",
      "padding": "3.5px",
      "border": {
        "radius": "6px"
      },
      "icon": {
        "disabled": {
          "color": "#475569"
        }
      },
      "font": {
        "weight": "500"
      },
      "disabled": {
        "background": "#E2E8F0",
        "color": "#475569",
        "border": {
          "color": "#E2E8F0"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        }
      },
      "focus": {
        "ring": {
          "width": "1px",
          "offset": "2px",
          "color": "#0284C7"
        }
      },
      "content": {
        "left": "3.5px",
        "top": "3.5px",
        "lg": {
          "padding": "3.5px 10.5px"
        },
        "sm": {
          "padding": "3.5px 10.5px"
        },
        "padding": "3.5px 10.5px",
        "border": {
          "radius": "6px"
        }
      },
      "sm": {
        "padding": "3.5px",
        "font": {
          "size": "12.25px"
        },
        "zadding": {
          "x": "10.5px",
          "y": "5.25px"
        }
      },
      "lg": {
        "padding": "3.5px",
        "font": {
          "size": "15.75px"
        },
        "zadding": {
          "x": "17.5px",
          "y": "8.75px"
        }
      },
      "colorScheme": {
        "light": {
          "background": "#F1F5F9",
          "color": "#334155",
          "checked": {
            "background": "#F1F5F9",
            "color": "#0F172A",
            "border": {
              "color": "#F1F5F9"
            }
          },
          "hover": {
            "background": "#F1F5F9",
            "color": "#334155"
          },
          "border": {
            "color": "#F1F5F9"
          },
          "icon": {
            "color": "#334155",
            "hover": {
              "color": "#334155"
            },
            "checked": {
              "color": "#0F172A"
            }
          },
          "content": {
            "checked": {
              "background": "#FFFFFF"
            }
          }
        },
        "dark": {
          "background": "#020617",
          "color": "#94A3B8",
          "checked": {
            "background": "#020617",
            "color": "#FFFFFF",
            "border": {
              "color": "#020617"
            }
          },
          "hover": {
            "background": "#020617",
            "color": "#CBD5E1"
          },
          "border": {
            "color": "#020617"
          },
          "icon": {
            "color": "#94A3B8",
            "hover": {
              "color": "#CBD5E1"
            },
            "checked": {
              "color": "#FFFFFF"
            }
          },
          "content": {
            "checked": {
              "background": "#1E293B"
            }
          }
        }
      }
    },
    "tree": {
      "background": "#FFFFFF",
      "color": "#334155",
      "padding": "14px",
      "gap": "2px",
      "indent": "14px",
      "node": {
        "color": "#334155",
        "gap": "3.5px",
        "padding": "3.5px 7px",
        "border": {
          "radius": "6px"
        },
        "hover": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#E8F8FB",
          "color": "#2175A0"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "-1px",
            "color": "#0284C7"
          }
        },
        "icon": {
          "color": "#64748B",
          "hover": {
            "color": "#475569"
          },
          "selected": {
            "color": "#2175A0"
          }
        },
        "toggle": {
          "button": {
            "size": "24.5px",
            "color": "#64748B",
            "border": {
              "radius": "12.25px"
            },
            "hover": {
              "background": "#F1F5F9",
              "color": "#475569"
            },
            "selected": {
              "hover": {
                "background": "#FFFFFF",
                "color": "#2175A0"
              }
            },
            "focus": {
              "ring": {
                "width": "1px",
                "offset": "2px",
                "color": "#0284C7"
              }
            }
          }
        }
      },
      "loading": {
        "icon": {
          "size": "28px"
        }
      },
      "filter": {
        "margin": "7px"
      }
    },
    "treeselect": {
      "background": "#FFFFFF",
      "color": "#334155",
      "tree": {
        "padding": "3.5px 3.5px"
      },
      "disabled": {
        "background": "#E2E8F0",
        "color": "#475569"
      },
      "filled": {
        "background": "#F8FAFC",
        "focus": {
          "background": "#F8FAFC"
        },
        "hover": {
          "background": "#F8FAFC"
        }
      },
      "border": {
        "color": "#CBD5E1",
        "radius": "6px"
      },
      "hover": {
        "border": {
          "color": "#94A3B8"
        }
      },
      "focus": {
        "border": {
          "color": "#2175A0"
        },
        "ring": {
          "width": "0px",
          "offset": "0px",
          "color": "transparent"
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        },
        "placeholder": {
          "color": "#DC2626"
        }
      },
      "placeholder": {
        "color": "#64748B"
      },
      "padding": {
        "x": "10.5px",
        "y": "7px"
      },
      "dropdown": {
        "width": "35px",
        "color": "#94A3B8"
      },
      "overlay": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "color": "#E2E8F0",
          "radius": "6px"
        }
      },
      "chip": {
        "border": {
          "radius": "4px"
        }
      },
      "sm": {
        "font": {
          "size": "12.25px"
        },
        "padding": {
          "x": "8.75px",
          "y": "5.25px"
        }
      },
      "lg": {
        "font": {
          "size": "15.75px"
        },
        "padding": {
          "x": "12.25px",
          "y": "8.75px"
        }
      },
      "clear": {
        "icon": {
          "color": "#94A3B8"
        }
      }
    },
    "toolbar": {
      "background": "#FFFFFF",
      "color": "#334155",
      "gap": "7px",
      "padding": "10.5px",
      "border": {
        "color": "#E2E8F0",
        "radius": "6px"
      }
    },
    "virtualscroller": {
      "loader": {
        "mask": {
          "background": "#FFFFFF",
          "color": "#64748B"
        },
        "icon": {
          "size": "28px"
        }
      }
    },
    "toggleswitch": {
      "width": "35px",
      "height": "21px",
      "gap": "3.5px",
      "border": {
        "radius": "30px",
        "width": "1px",
        "color": "transparent"
      },
      "hover": {
        "border": {
          "color": "transparent"
        }
      },
      "checked": {
        "border": {
          "color": "transparent"
        },
        "hover": {
          "border": {
            "color": "transparent"
          }
        }
      },
      "invalid": {
        "border": {
          "color": "#F87171"
        }
      },
      "handle": {
        "size": "14px",
        "border": {
          "radius": "7px"
        }
      },
      "focus": {
        "ring": {
          "width": "1px",
          "color": "#0284C7",
          "offset": "2px"
        }
      },
      "colorScheme": {
        "light": {
          "background": "#CBD5E1",
          "hover": {
            "background": "#94A3B8"
          },
          "checked": {
            "background": "#2175A0",
            "hover": {
              "background": "#0284C7"
            }
          },
          "handle": {
            "background": "#FFFFFF",
            "color": "#64748B",
            "hover": {
              "background": "#FFFFFF",
              "color": "#334155"
            },
            "checked": {
              "background": "#FFFFFF",
              "color": "#2175A0",
              "hover": {
                "background": "#FFFFFF",
                "color": "#0284C7"
              }
            },
            "disabled": {
              "background": "#475569"
            }
          },
          "disabled": {
            "background": "#E2E8F0"
          }
        },
        "dark": {
          "background": "#334155",
          "hover": {
            "background": "#475569"
          },
          "checked": {
            "background": "#2175A0",
            "hover": {
              "background": "#0284C7"
            }
          },
          "handle": {
            "background": "#94A3B8",
            "color": "#0F172A",
            "hover": {
              "background": "#CBD5E1",
              "color": "#1E293B"
            },
            "checked": {
              "background": "#0F172A",
              "color": "#2175A0",
              "hover": {
                "background": "#0F172A",
                "color": "#0284C7"
              }
            },
            "disabled": {
              "background": "#0F172A"
            }
          },
          "disabled": {
            "background": "#475569"
          }
        }
      }
    },
    "tooltip": {
      "gutter": "3.5px",
      "max": {
        "width": "175px"
      },
      "padding": "7px 10.5px",
      "border": {
        "radius": "6px"
      },
      "colorScheme": {
        "light": {
          "background": "#334155",
          "color": "#FFFFFF"
        },
        "dark": {
          "background": "#334155",
          "color": "#FFFFFF"
        }
      }
    },
    "treetable": {
      "header": {
        "background": "#FFFFFF",
        "color": "#334155",
        "border": {
          "color": "#E2E8F0",
          "width": "1px"
        },
        "padding": "10.5px 14px",
        "cell": {
          "background": "#FFFFFF",
          "color": "#334155",
          "gap": "7px",
          "hover": {
            "background": "#F1F5F9",
            "color": "#1E293B"
          },
          "selected": {
            "background": "#E8F8FB",
            "color": "#2175A0"
          },
          "border": {
            "color": "#E2E8F0"
          },
          "padding": "10.5px 14px",
          "focus": {
            "ring": {
              "width": "1px",
              "offset": "-1px",
              "color": "#0284C7"
            }
          }
        }
      },
      "column": {
        "title": {
          "font": {
            "weight": "600"
          }
        },
        "footer": {
          "font": {
            "weight": "600"
          }
        },
        "resizer": {
          "width": "7px"
        }
      },
      "row": {
        "background": "#FFFFFF",
        "color": "#334155",
        "hover": {
          "background": "#F1F5F9",
          "color": "#1E293B"
        },
        "selected": {
          "background": "#E8F8FB",
          "color": "#2175A0"
        },
        "focus": {
          "ring": {
            "width": "1px",
            "offset": "-1px",
            "color": "#0284C7"
          }
        }
      },
      "body": {
        "cell": {
          "gap": "7px",
          "border": {
            "color": "#E2E8F0"
          },
          "padding": "10.5px 14px"
        }
      },
      "footer": {
        "background": "#FFFFFF",
        "color": "#334155",
        "cell": {
          "background": "#FFFFFF",
          "color": "#334155",
          "border": {
            "color": "#E2E8F0"
          },
          "padding": "10.5px 14px"
        },
        "border": {
          "color": "#E2E8F0",
          "width": "1px"
        },
        "padding": "10.5px 14px"
      },
      "resize": {
        "indicator": {
          "width": "1px",
          "color": "#2175A0"
        }
      },
      "sort": {
        "icon": {
          "color": "#64748B",
          "size": "12.25px",
          "hover": {
            "color": "#475569"
          }
        }
      },
      "loading": {
        "icon": {
          "size": "28px"
        }
      },
      "node": {
        "toggle": {
          "button": {
            "color": "#64748B",
            "size": "24.5px",
            "hover": {
              "background": "#F1F5F9",
              "color": "#334155"
            },
            "selected": {
              "hover": {
                "background": "#FFFFFF",
                "color": "#2175A0"
              }
            },
            "border": {
              "radius": "12.25px"
            },
            "focus": {
              "ring": {
                "width": "1px",
                "offset": "2px",
                "color": "#0284C7"
              }
            }
          }
        }
      },
      "paginator": {
        "top": {
          "border": {
            "color": "#E2E8F0",
            "width": "1px"
          }
        },
        "bottom": {
          "border": {
            "width": "1px",
            "color": "#E2E8F0"
          }
        }
      },
      "figma": {
        "body": {
          "cell": {
            "padding": {
              "sm": "5.25px",
              "lg": "13.125px"
            }
          }
        },
        "footer": {
          "cell": {
            "padding": {
              "sm": "5.25px",
              "lg": "13.125px"
            }
          },
          "padding": {
            "sm": "5.25px",
            "lg": "13.125px"
          }
        },
        "header": {
          "cell": {
            "padding": {
              "sm": "5.25px",
              "lg": "13.125px"
            }
          },
          "padding": {
            "sm": "5.25px",
            "lg": "13.125px"
          }
        }
      },
      "colorScheme": {
        "light": {
          "border": {
            "color": "#E2E8F0"
          },
          "body": {
            "cell": {
              "selected": {
                "border": {
                  "color": "#CFEFF6"
                }
              }
            }
          }
        },
        "dark": {
          "border": {
            "color": "#1E293B"
          },
          "body": {
            "cell": {
              "selected": {
                "border": {
                  "color": "#175270"
                }
              }
            }
          }
        }
      }
    }
  }
});
